import { CSSProperties } from 'react'

type MapData = {
  [key: string]: {
    name: string
    pathGroup: React.ReactNode
    style: CSSProperties
  }
}

export const mapData: MapData = {
  '11000': {
    name: '서울',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="299.9 202 304.1 213.3 304.1 224.7 299.9 228.8 304.1 234 310.7 229.9 317.2 235.5 309.9 240 308.8 249.3 304.5 253.8 294.1 262.7 285.2 262.7 280.2 255.2 266.3 260.8 251.3 247.1 243.2 247.4 243.6 237 240.5 232.3 233.9 232.3 237 220.9 245.1 218.4 249.7 224.7 257.5 224.7 268.6 207.9 274 213.1 284.5 202 299.9 202"
        />
      </>
    ),
    style: { top: '83px', left: '98px' },
  },
  '26000': {
    name: '부산',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="694.1 778.6 701.1 796 686.4 809.9 686.4 821.3 661 842.7 661 850.6 645.8 844.6 650.4 856.6 639.1 853.6 628.8 856.6 624.7 842.7 613.9 849.6 595.4 845.1 596.4 833.7 592.5 822.3 605.7 822.3 611.3 810.8 633.5 810.8 639.1 797.4 654 797.4 681.3 778.6 694.1 778.6"
        />
      </>
    ),
    style: { top: '268px', left: '237px' },
  },
  '27000': {
    name: '대구',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="588.8 621.4 592.5 624.2 598.9 629 598.9 636.5 594.6 639.5 598.9 649.9 598.9 654.3 587.7 659.9 587.7 670.7 580.7 675.6 584.6 681.9 584.6 692 567.2 692 561 683.8 555.5 683.8 548.1 696.6 538.8 708 523.4 710.5 512 692.7 515.9 689.4 523.4 693.8 530.6 689.4 521.3 677.8 526.3 667 539.8 667 539.8 660.3 535.2 655.8 525.9 655.8 522.1 649.1 532.5 638.7 539.8 636.5 542.2 646.9 547.5 649.5 556 636.5 559.9 629.8 573.8 621.4 588.8 621.4"
        />
      </>
    ),
    style: { top: '228px', left: '193px' },
  },
  '28000': {
    name: '인천',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="145.4 156 157.6 161.7 151.7 168.7 133.2 168.7 137.1 160 145.4 156"
        />
        <polygon
          className="st1"
          points="149.8 173.7 154.7 174.3 154.6 183.4 162 191.7 161.5 195.6 156.7 200.6 149.6 199.7 151.6 194.5 143.8 184.4 149.8 173.7"
        />
        <path
          className="st0"
          d="M100.3,281.2l7.7,7.2c0,.4.5,8,0,8.7h-9.8l-2.8-11.2,4.9-4.7h0Z"
        />
        <polygon
          className="st0"
          points="101.8 303.3 101.8 307.8 95.4 313.5 91 309.5 97 303.3 101.8 303.3"
        />
        <polygon
          className="st0"
          points="95.4 320.5 95.4 325.7 85.4 331.4 82.3 327.9 90 320.5 95.4 320.5"
        />
        <polygon
          className="st1"
          points="178 157.2 191.1 172.9 191.1 207.9 186.8 212 174.5 213.9 162.5 204.2 167.9 202 168.7 193 162.5 184.6 162.5 163.6 178 157.2"
        />
        <polygon
          className="st1"
          points="157.6 222.1 165.1 225.6 160.5 230.8 152.2 230.8 147.4 225.6 150.4 222.1 157.6 222.1"
        />
        <polygon
          className="st1"
          points="192.6 228.3 199.8 234.8 199.8 241 191.1 243 176.8 253.1 169.5 253.1 159.4 241 165.9 234.6 183.6 234.6 186.8 228.3 192.6 228.3"
        />
        <polygon
          className="st1"
          points="217.7 207.9 223.9 217.6 237 220.9 233.9 232.3 232.8 238.9 225.8 238.5 225.8 245.6 232 249.3 233.1 257.9 224.6 266.4 217.7 266.8 205.8 247.4 203.1 217.6 210.4 207.9 217.7 207.9"
        />
        <polygon
          className="st1"
          points="167.4 258.4 167.4 269 159.4 270.5 157.6 266.8 162.5 258.4 167.4 258.4"
        />
        <polygon
          className="st0"
          points="176.8 284.5 183.4 289.4 172.6 299.9 165.1 293.6 176.8 284.5"
        />
        <polygon
          className="st1"
          points="136.1 194 142 199.2 131.2 207.9 129.6 203.7 136.1 194"
        />
      </>
    ),
    style: { top: '85px', left: '61px' },
  },
  '30000': {
    name: '대전',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="329.3 487.4 341.8 500.3 359.3 503.3 364.9 512.2 355.7 528.7 352.6 551 339.7 560.4 317.2 554 309.9 545.5 304.2 531.6 309.9 523.9 313 503.3 326.4 498.8 329.3 487.4"
        />
      </>
    ),
    style: { top: '188px', left: '137px' },
  },
  '31000': {
    name: '울산',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="673.6 696.6 695.2 701.5 695.2 715.5 706.5 715.5 718.3 710 738.9 719.2 736.6 743 727.3 762.4 718.8 755.7 711.1 769.1 712.7 787.8 701.1 796 694.1 778.6 681.3 778.6 681.3 767.6 656.6 747.3 639.1 740.8 639.1 731.4 650.4 725.4 650.4 715.5 658.1 715.5 658.1 705.5 673.6 696.6"
        />
      </>
    ),
    style: { top: '230px', left: '231px' },
  },
  '36000': {
    name: '세종',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="304.8 428.3 312 438.7 320.2 438.7 319.3 468 331.5 478.5 329.3 487.4 326.4 498.8 313 503.3 303.2 492.9 299.1 464.1 288.3 453.1 288.3 434.2 291.9 428.3 304.8 428.3"
        />
      </>
    ),
    style: { top: '170px', left: '111px' },
  },
  '41000': {
    name: '경기',
    pathGroup: (
      <>
        <polygon
          className="st0"
          points="314.4 64.3 314.4 73.5 325.9 73.5 325.9 90.9 336.1 98.4 348.5 89.9 351.6 98.4 347.5 105.3 355.7 115.3 362.4 108.8 379.4 108.8 379.4 124.2 379.4 132.7 392.7 132.7 408.7 151.1 408.7 164 390.1 174.4 390.1 195.8 382.4 201.7 391.2 204.2 390.7 224.6 404 224.6 421.4 237 439.5 240 446.7 245.9 443.6 252.4 428.2 256.4 428.7 261.8 437 270.3 426.2 290.2 419.3 329.9 409.7 339.9 397.9 339.9 397.9 351.8 378.3 358.7 369.1 354.8 327.9 386.5 324.3 395 303.2 372.6 289.3 374.1 284.7 382.1 254 382.7 234.3 361.5 225 352.1 227 336.5 238.9 328.3 234.7 320.1 219.2 328.7 210.4 329 204.6 316.4 203.4 305.9 186.8 306.3 188.4 299.2 194.2 291.4 220 289.9 225.8 293.3 229.7 290.7 217.7 278.4 224.6 266.4 233.1 257.9 232 249.3 225.8 245.6 225.8 238.5 232.8 238.9 233.9 232.3 240.5 232.3 243.6 237 243.2 247.4 251.3 247.1 266.3 260.8 280.2 255.2 285.2 262.7 294.1 262.7 308.8 249.3 309.9 240 317.2 235.5 310.7 229.9 304.1 234 299.9 228.8 304.1 224.7 304.1 213.3 299.9 202 284.5 202 274 213.1 268.6 207.9 257.5 224.7 249.7 224.7 245.1 218.4 237 220.9 223.9 217.6 217.7 207.9 210.4 207.9 203.1 217.6 196.5 206.1 198 177.4 219.6 176.6 220.8 196 223.5 200.1 227.7 195.6 229.3 168.4 225.8 161.4 238.5 155 231.6 142.7 219.6 139.7 223.9 131.9 235.8 136.4 242.4 129.3 247.4 133.4 243.6 140.9 250.5 148.7 257.5 139.7 252 127.8 257.8 117.8 266.3 122.2 271 112.2 263.6 102.8 249.7 104.7 242.8 88.7 270.6 71.9 288.7 81.2 291.8 69.3 303.7 69.7 314.4 64.3"
        />
      </>
    ),
    style: { top: '110px', left: '107px' },
  },
  '43000': {
    name: '충북',
    pathGroup: (
      <>
        <polygon
          className="st0"
          points="476.6 320.5 476.6 335.9 484.8 335.9 513.1 324.4 534.7 330.9 537.8 338.4 521.3 344.8 528 352.3 542.4 345.3 553.7 359.2 572.2 359.2 596.4 374.6 580.5 379.1 555.3 399 551.7 419.3 549.1 429.8 534.2 429.8 515.1 414.9 501.8 425.3 487.4 419.8 484.8 426.8 477.6 425.3 468.3 429.8 475 446.2 457 442.2 439 452.1 446.7 462.1 446.7 470 432.9 462.6 421.4 470 436.5 490.4 430.8 521.7 433.4 529.6 421.4 538.1 423.6 545 436.5 545 443.1 552 459.1 552 462.2 570.4 446.7 570.4 446.7 581.8 439.5 602.2 421.4 608.6 415.4 603.7 402 606.2 374.2 594.7 371.6 560.4 352.6 551 355.7 528.7 364.9 512.2 359.3 503.3 341.8 500.3 329.3 487.4 331.5 478.5 319.3 468 320.2 438.7 337.3 427.3 342.8 432.3 350.4 425.8 341.8 414.9 334.6 410.9 324.3 395 327.9 386.5 369.1 354.8 378.3 358.7 397.9 351.8 397.9 339.9 409.7 339.9 419.3 329.9 427.2 341.3 453.9 341.3 456.5 335.6 453.9 325.4 459.6 320.5 476.6 320.5"
        />
      </>
    ),
    style: { top: '140px', left: '145px' },
  },
  '44000': {
    name: '충남',
    pathGroup: (
      <>
        <polygon
          className="st0"
          points="176 342.8 197.6 357.4 222.3 364.1 233.5 382 236.6 394.6 254 382.7 284.7 382.1 289.3 374.1 303.2 372.6 324.3 395 334.6 410.9 341.8 414.9 350.4 425.8 342.8 432.3 337.3 427.3 320.2 438.7 312 438.7 304.8 428.3 291.9 428.3 288.3 434.2 288.3 453.1 299.1 464.1 303.2 492.9 313 503.3 309.9 523.9 304.2 531.6 309.9 545.5 317.2 554 339.7 560.4 352.6 551 371.6 560.4 374.2 594.7 371.6 608.6 361.3 599.2 356.2 598.7 350.4 611.6 335.3 607.7 323.8 603.2 320.2 578.3 313 578.3 277.5 582.3 264.1 581.3 260 567.4 234.3 562.9 219.9 583.8 211.7 590.3 201.9 589.8 193.4 599.6 180.3 582.8 164.9 560.4 150.6 559.7 161.8 545.2 162.1 523.9 158.3 516.8 166.4 509 156.4 497.1 158.3 466.9 159.1 439.3 154.4 438.2 149.8 444.2 142.9 444.2 135.9 437.5 129 445.7 121.3 445.7 118.2 419.2 107.4 425.2 99.3 425.2 99.3 418.5 105.4 418.5 105.4 410.6 99.3 410.6 94.6 415.1 90 409.1 98.9 389.8 109.3 384.9 115.1 373.8 121.6 373 128.2 366.7 134.4 366.7 134 387.5 141.7 388.3 152.5 379.3 152.1 371.1 142.1 365.2 145.6 354 161 352.5 168.7 363 172.2 355.9 167.2 345.4 176 342.8"
        />
        <polygon
          className="st0"
          points="133 444.9 139.9 447.4 143.8 468.3 147.6 490.6 140.2 490.6 128.3 482.7 128.3 449.9 133 444.9"
        />
        <polygon
          className="st0"
          points="124.5 506.8 131.4 513 124.5 516.7 120.1 511.8 124.5 506.8"
        />
      </>
    ),
    style: { top: '160px', left: '75px' },
  },
  '12000': {
    name: '전남광주',
    pathGroup: (
      <>
        {/* 광주 (구 29000) - 전남과 병합 */}
        <polygon
          className="st0"
          points="207.3 771.7 217.3 775.1 225 790 235.1 790 235.1 801.2 226.6 813.1 216.2 818.3 207.7 813.8 201.1 818.3 185.7 818.3 176 806.4 159.8 804.9 157.9 788.1 164.9 783.3 174.1 778.4 177.2 771.7 183 771.7 185.7 779.2 196.1 779.2 207.3 771.7"
        />
        <polygon
          className="st0"
          points="207.3 771.7 217.3 775.1 225 790 235.1 790 235.1 801.2 226.6 813.1 216.2 818.3 207.7 813.8 201.1 818.3 185.7 818.3 176 806.4 159.8 804.9 157.9 788.1 164.9 783.3 174.1 778.4 177.2 771.7 183 771.7 185.7 779.2 196.1 779.2 207.3 771.7"
        />
        <polygon
          className="st0"
          points="57.2 786.3 54.5 803 45.3 807.5 36.8 798.6 51.2 786.3 57.2 786.3"
        />
        <polygon
          className="st0"
          points="84.6 787.8 89.2 790 99.3 790 99.3 801.9 78.4 818.3 61.1 801.9 65.7 794.8 77.7 798.9 84.6 787.8"
        />
        <polygon
          className="st0"
          points="57.2 807.5 67.6 814.2 67.6 825 61.1 825 52.6 813.5 57.2 807.5"
        />
        <polygon
          className="st0"
          points="38.6 834.5 43.7 839.7 43.7 846.1 34.5 853.2 24.2 850.8 22.1 843.4 38.6 834.5"
        />
        <polygon
          className="st0"
          points="92.5 846.4 92.5 854.8 96.8 859.7 89.3 864.2 84 859.1 73 859.1 73 854.8 84.3 852.5 84.3 846.4 92.5 846.4"
        />
        <polygon
          className="st0"
          points="50.5 848.9 57.2 853.2 46 864.8 36.8 864.8 36.8 856.8 50.5 848.9"
        />
        <polygon
          className="st0"
          points="17.8 862 23.7 866 19.8 873 12.9 873 6.2 880.9 0 880.9 0 867.5 11.6 867.5 17.8 862"
        />
        <polygon
          className="st0"
          points="39.9 873 48.9 874.2 60.1 884.9 52 892.6 36.8 877.4 39.9 873"
        />
        <polygon
          className="st0"
          points="14.9 880.9 21 886.9 21 892.6 14.9 899.3 10.3 899.3 2.6 893.8 2.6 887.9 14.9 880.9"
        />
        <polygon
          className="st0"
          points="55 897.5 61.1 904.4 55 911.2 45.3 911.2 39.9 906.2 47 897.5 55 897.5"
        />
        <polygon
          className="st0"
          points="35.7 908 38.8 915.2 38.8 922.6 27.5 931.3 21 926.6 29.9 918.4 27.5 908 35.7 908"
        />
        <polygon
          className="st0"
          points="382.8 924.9 382.8 933.8 379.4 936.4 382.8 941.8 382.8 948.2 376.6 948.2 365.9 937.7 365.9 931.2 373.8 924.9 382.8 924.9"
        />
        <polygon
          className="st0"
          points="361 945.9 361 950.6 356.1 953.6 351.2 953.6 351.2 945.9 361 945.9"
        />
        <polygon
          className="st0"
          points="370.1 952.5 376.6 955.1 376.6 964.6 381.1 967.2 378.4 972.4 362.8 957.7 370.1 952.5"
        />
        <polygon
          className="st0"
          points="263.6 959.3 265.9 969.1 258.6 975 251.3 975 237 969.1 238.4 962 249 962 252.2 959.3 263.6 959.3"
        />
        <polygon
          className="st0"
          points="228.7 963.3 232.4 968.1 232.4 975 225.4 975 224.1 965.9 228.7 963.3"
        />
        <polygon
          className="st0"
          points="74.6 924.1 94.1 945 86.7 965.6 55.7 976 42.4 975.1 36.8 954 58.9 936.6 72.5 936.6 70.3 928.4 74.6 924.1"
        />
        <polygon
          className="st0"
          points="176.6 965.9 187.4 973 187.4 977 174.7 981.2 167.9 981.2 166.5 972.8 176.6 965.9"
        />
        <polygon
          className="st0"
          points="319.7 970.2 327.1 976.5 324.4 983.2 318.7 983.2 310.3 970.2 319.7 970.2"
        />
        <polygon
          className="st0"
          points="193.6 973.5 206.1 979.7 204 985.8 193.6 985.8 188.8 979.8 193.6 973.5"
        />
        <polygon
          className="st0"
          points="384.5 978.9 384.5 985.1 381.1 989.5 375.9 987.9 378.2 978.9 384.5 978.9"
        />
        <path
          className="st0"
          d="M367.8,889.1l7.3-3.4h6.2v17.1l-6.6,4.5,6.6,9.3-3.9,4.1-8.1-5.6-7.3.4-5-3-9.3,8.2,1.5,12.7h-5.4l-9.2-5.2v-14.9l6.2-4.8-1.1-11.2-7.7-6v-6.3h-17.4l-11.6,10.4v22l18.9,19.4-5,9.3h-13.9v10.8l-22.8,20.1-13.5-22.7h-27.4v-9.7l18.1-14.2,4.2,5.6,5.8-4.1,1.9-12.3,5-8.6,6.5,9.3,7-4.5-.4-10.8-18.1-3-12.3,11.9-13.5,1.9-15.1,8.6-11.6,6-1.9,17.5-4.6,3.7v10.4l-8.1,4.5h-10l-4.6,2.6-11.6-7.5v-19l3.5-6.3-5.8-3.3-5.8,9.7v11.5l-6.9,4.5v7.1l-13.5.4-11.6,8.9-2.3,15.7h-19.7l-2.3-8.6-6.6-7.5,9.7-9.3-6.6-5.6-.8-23.1-11.6-1.5-19.7-17.1v-8.6l-5.8-4.8,4.2-17.1,6.6-1.1,7.7,5.2-1.2,13,7.7,13.8h6.9v-5.6l-8.9-9.7-.4-6.3h12.7l10.4,9.7,6.6.4v-7.1l-10-9.7h-14.3l-5.2-5,.6-18.8,11.6-7.1-1.5-18.6-9.3,4.5-8.1-9.3,13.1-13.8-3.5-4.8-.4-7.5,9.7.7,4.2,8.6h5l.8-7.1,5.8-5.2-18.1-20.5.8-5.6-12.7-7.1v-4.5l8.1-4.8,19.3-26.1-.4-8.6,3-3.2h11.8l-3.1,9.9,10.8,19.4,8.2-5.5,8.7,4.5,23.1-13.9v-15.9l8.2-4,13.4-5.5,10.8,9.9,4.1,14.9,11.3,4v-13.4l12.4-8,6.2,9.4-5.1,8.8,5.1,8.6-6.2,7,9.8,9.2,18-6.2,42.7,10,11.3-12.9,17.5,3.5,12.4,14.9,3.1,29.3,13.4,7v11.9l20.1,21.9-21.7,23.1-7,5.2-13.9-4.1-3.9,4.5,10.8,15.3h14.3ZM235.1"
        />
        <polygon
          className="st0"
          points="217.7 983.2 234.1 990.8 229.7 997.4 222.5 997.4 214 987.5 217.7 983.2"
        />
        <polygon
          className="st0"
          points="154.2 971.5 163.1 986.9 184.1 986.9 189.7 990.8 187.2 998.3 181.6 998.3 172.2 992 167.4 992.1 165.6 998.3 154.6 998.3 143.2 987.7 145 971.5 154.2 971.5"
        />
        <polygon
          className="st0"
          points="18.3 981 29.9 983.4 28.3 990.8 21 990.8 14 985.1 18.3 981"
        />
        <polygon
          className="st0"
          points="125.9 1010 134 1015.4 131.9 1022.7 125.1 1023.8 118.3 1014.9 125.9 1010"
        />
        <polygon
          className="st0"
          points="114.1 1022.7 129.2 1027.3 123.8 1033.5 110.7 1036.8 107.4 1028.1 114.1 1022.7"
        />
        <polygon
          className="st0"
          points="188.8 1019.2 194.9 1023.8 193.8 1033.3 184.5 1033.3 182 1024.7 188.8 1019.2"
        />
        <polygon
          className="st0"
          points="204.2 990.8 214 994.6 210.1 998.3 204.2 995.7 204.2 990.8"
        />
      </>
    ),
    style: { top: '290px', left: '85px' },
  },
  '47000': {
    name: '경북',
    pathGroup: (
      <>
        <polygon
          className="st0"
          points="737.3 363 751.2 383.8 751.2 436.7 757.4 457.6 742.8 495.6 747.4 516.5 746.6 532.9 732 553 728.1 595.5 737.3 607.4 737.3 616.3 725 626 740.4 641.7 761.3 622.3 768.2 630.5 758.2 659.6 738.9 719.2 718.3 710 706.5 715.5 695.2 715.5 695.2 701.5 673.6 696.6 658.1 705.5 658.1 715.5 650.4 715.5 621.1 715.5 602.6 727.4 591.8 727.4 570.7 718.4 560.4 722.4 553.2 715.5 548.1 696.6 555.5 683.8 561 683.8 567.2 692 584.6 692 584.6 681.9 580.7 675.6 587.7 670.7 587.7 659.9 598.9 654.3 598.9 649.9 594.6 639.5 598.9 636.5 598.9 629 592.5 624.2 588.8 621.4 573.8 621.4 559.9 629.8 556 636.5 547.5 649.5 542.2 646.9 539.8 636.5 532.5 638.7 522.1 649.1 525.9 655.8 535.2 655.8 539.8 660.3 539.8 667 526.3 667 521.3 677.8 530.6 689.4 523.4 693.8 515.9 689.4 512 692.7 523.4 710.5 514.1 715.5 506.9 705 480.2 702 474.5 697.1 484.8 690.1 484.8 682.2 474.5 669.3 462.7 655.3 453.7 655.3 444.2 655.3 421.4 636.5 430.8 621.6 423.6 615.6 421.4 608.6 439.5 602.2 446.7 581.8 446.7 570.4 462.2 570.4 459.1 552 443.1 552 436.5 545 423.6 545 421.4 538.1 433.4 529.6 430.8 521.7 436.5 490.4 421.4 470 432.9 462.6 446.7 470 446.7 462.1 439 452.1 457 442.2 475 446.2 468.3 429.8 477.6 425.3 484.8 426.8 487.4 419.8 501.8 425.3 515.1 414.9 534.2 429.8 549.1 429.8 551.7 419.3 555.3 399 580.5 379.1 596.4 374.6 615.5 382.1 619 374.1 631.4 368.7 639.6 382.1 646.8 377.6 653 371.1 675.1 377.1 685.9 372.1 704.9 386 715.2 373.6 737.3 363"
        />
        <polygon
          className="st0"
          points="816.4 284 824.5 299.6 813.3 310 806.2 310 796 297.4 799.8 289.9 808.7 289.9 816.4 284"
        />
        <polygon
          className="st0"
          points="841.9 307.4 850 318.6 841.9 322.7 833.4 314.5 841.9 307.4"
        />
      </>
    ),
    style: { top: '170px', left: '203px' },
  },
  '48000': {
    name: '경남',
    pathGroup: (
      <>
        <polygon
          className="st0"
          points="536.9 865 541.4 867.5 538.8 874.7 532.4 874.7 536.9 865"
        />
        <polygon
          className="st0"
          points="435 870 432.6 878.9 440.8 878.9 447.2 886.4 447.2 892.6 440.8 892.6 435.4 887.6 421.4 887.4 421.4 878.9 428.6 870 435 870"
        />
        <polygon
          className="st0"
          points="473.5 887.9 480.9 895.8 480.9 902.3 470.4 902.3 470.4 892.6 462.9 892.6 468.3 887.9 473.5 887.9"
        />
        <polygon
          className="st0"
          points="529.4 906.2 532.4 913 525 915.6 522.1 906.2 529.4 906.2"
        />
        <polygon
          className="st0"
          points="421.4 636.5 444.2 655.3 453.7 655.3 462.7 655.3 474.5 669.3 484.8 682.2 484.8 690.1 474.5 697.1 480.2 702 506.9 705 514.1 715.5 523.4 710.5 538.8 708 548.1 696.6 553.2 715.5 560.4 722.4 570.7 718.4 591.8 727.4 602.6 727.4 621.1 715.5 650.4 715.5 650.4 725.4 639.1 731.4 639.1 740.8 656.6 747.3 681.3 767.6 681.3 778.6 654 797.4 639.1 797.4 633.5 810.8 611.3 810.8 605.7 822.3 592.5 822.3 596.4 833.7 595.4 845.1 576.9 844.1 555.2 822.8 553.7 835.7 556.8 845.1 551.7 850.6 542.4 838.2 528.5 841.2 528.5 856.6 522.1 862.2 518.2 865.5 514.6 885.4 523.9 885.4 525.2 892.1 516.7 903.6 518.6 911.1 514.6 920.8 508.6 920.8 500.5 907.7 492.4 906.6 492.4 902.2 506.3 896.2 505.5 890.2 495.5 892.1 487 887.6 487 884.3 494.7 883.5 496.2 874.2 487 879 472.3 873.5 468.5 880.5 454.6 880.2 441.5 872.3 439.5 854.5 439.5 842.9 431.8 850 431.8 858.2 421.4 858.2 416.4 856.3 405.6 864.9 386.3 865.3 386.3 876.1 379.4 876.8 367.4 868.2 389.1 845.1 369.1 823.3 369.1 811.3 355.7 804.4 352.6 775.1 355.2 763.7 355.2 754.7 369.1 746.3 367.5 725.4 358.3 717 358.3 709 375.2 666.8 380.2 663 384.5 659.8 392.7 650.9 421.4 636.5"
        />
        <polygon
          className="st0"
          points="416.9 870 416.9 875.7 410.7 881.2 410.2 886.6 416.9 894.8 430.8 893.8 442.6 897.4 442.6 902.8 438.2 907.2 438.2 922.2 433.1 924.9 430.8 921.7 415.6 916.4 417.7 905.2 412.3 903.8 406.6 917.4 398.4 917.4 393.5 908.2 397.4 906.2 397.4 899.8 391.2 889.6 391.2 881.7 403.5 870 416.9 870"
        />
        <polygon
          className="st0"
          points="465.3 918.9 469.2 922.6 469.2 929.3 460.2 929.3 458.2 924.9 465.3 918.9"
        />
        <polygon
          className="st0"
          points="578.7 855.6 578.7 864 571 870 580.2 881.3 569.9 888.6 573 892.6 579.2 889.1 585.6 889.1 585.6 895.8 574.3 903 581.2 909.5 573.8 915 568.6 906.5 559.1 915.9 559.1 924.9 550.9 932.8 544.7 932.8 544.7 913.2 540.3 913.2 548.8 903.8 545 897.4 539.3 905.5 534.4 905.5 527.7 897.4 527.7 888.4 535.7 881.3 546.5 881.3 551.9 888.4 558.1 884.6 551.9 878.4 551.9 872.5 559.6 872.5 559.6 864.3 569.9 855.6 578.7 855.6"
        />
        <polygon
          className="st0"
          points="474.1 937.4 482.7 942.8 482.7 948.2 471.9 948.2 469.2 940.7 474.1 937.4"
        />
      </>
    ),
    style: { top: '268px', left: '169px' },
  },
  '50000': {
    name: '제주',
    pathGroup: (
      <>
        <polygon
          className="st1"
          points="788.1 977.4 786.3 968.9 760.9 954 725 955.9 706.9 961.5 673.3 964.4 646.8 977.8 622.8 999.8 626.2 1013.6 633.6 1021.5 644.4 1033 650.9 1033 657.1 1025.2 699.2 1027.4 713.8 1033 725 1025.6 741.2 1025.6 772.1 1015.5 790.2 987.2 788.1 977.4"
        />
      </>
    ),
    style: { top: '346px', left: '245px' },
  },
  '51000': {
    name: '강원',
    pathGroup: (
      <>
        <polygon
          className="st0"
          points="566.1 0 607.7 94.7 626.2 146.1 653.2 186.3 688.7 240.7 693.4 255.6 737.3 335.4 737.3 363 715.2 373.6 704.9 386 685.9 372.1 675.1 377.1 653 371.1 646.8 377.6 639.6 382.1 631.4 368.7 619 374.1 615.5 382.1 596.4 374.6 572.2 359.2 553.7 359.2 542.4 345.3 528 352.3 521.3 344.8 537.8 338.4 534.7 330.9 513.1 324.4 484.8 335.9 476.6 335.9 476.6 320.5 459.6 320.5 453.9 325.4 456.5 335.6 453.9 341.3 427.2 341.3 419.3 329.9 426.2 290.2 437 270.3 428.7 261.8 428.2 256.4 443.6 252.4 446.7 245.9 439.5 240 421.4 237 404 224.6 390.7 224.6 391.2 204.2 382.4 201.7 390.1 195.8 390.1 174.4 408.7 164 408.7 151.1 392.7 132.7 379.4 132.7 379.4 124.2 379.4 108.8 362.4 108.8 355.7 115.3 347.5 105.3 351.6 98.4 348.5 89.9 336.1 98.4 325.9 90.9 325.9 73.5 314.4 73.5 314.4 64.3 317.6 62.6 326.1 54.4 379.4 55.5 394.8 63.7 409.4 58.9 444.9 58.5 456.9 65.6 467.7 60.7 489.7 69.7 506.3 69.3 512 66 531 57.8 553.7 32.8 553.7 8.9 566.1 0"
        />
      </>
    ),
    style: { top: '68px', left: '185px' },
  },
  '52000': {
    name: '전북',
    pathGroup: (
      <>
        <polygon
          className="st0"
          points="234.3 562.9 260 567.4 264.1 581.3 277.5 582.3 313 578.3 320.2 578.3 323.8 603.2 335.3 607.7 350.4 611.6 356.2 598.7 361.3 599.2 371.6 608.6 374.2 594.7 402 606.2 415.4 603.7 421.4 608.6 423.6 615.6 430.8 621.6 421.4 636.5 392.7 650.9 384.5 659.8 380.2 663 375.2 666.8 358.3 709 358.3 717 367.5 725.4 369.1 746.3 355.2 754.7 355.2 763.7 352.6 775.1 340.2 760.2 322.8 756.7 311.5 769.6 268.8 759.7 250.8 765.9 241 756.7 247.2 749.7 242 741.2 247.2 732.3 241 722.9 228.6 730.9 228.6 744.3 217.3 740.3 213.2 725.4 202.4 715.5 189 720.9 180.8 724.9 180.8 740.8 157.6 754.7 148.9 750.2 140.7 755.7 129.9 736.3 133 726.4 121.2 726.4 125.5 721.8 142.9 703.9 157.5 702.4 173.7 698.3 173.3 692.7 142.5 691.2 136.7 686.4 136.3 675.2 162.1 662.5 175.3 645 184.9 644.7 199.6 652.5 202.7 645.8 185.7 634.2 186.5 629.4 203.4 626.8 211.9 618.2 183.8 621.9 171.8 623 171 612.6 167.2 607.8 154.4 607 159.1 600.3 193.4 599.6 201.9 589.8 211.7 590.3 219.9 583.8 234.3 562.9"
        />
      </>
    ),
    style: { top: '230px', left: '95px' },
  },
}

export const mapBgGroup: React.SVGProps<SVGGElement> = (
  <>
    <g className="st3">
      <polygon
        className="st2"
        points="157.6 161.7 157.6 187.6 151.7 194.6 151.7 168.7 157.6 161.7"
      />
      <rect className="st2" x="133.2" y="168.7" width="18.5" height="25.9" />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="154.7 174.3 154.7 200.2 154.6 209.3 154.6 183.4 154.7 174.3"
      />
      <polygon
        className="st2"
        points="151.6 194.5 151.6 220.3 143.8 210.3 143.8 184.4 151.6 194.5"
      />
      <polygon
        className="st2"
        points="162 191.7 162 217.6 161.5 221.5 161.5 195.6 162 191.7"
      />
      <polygon
        className="st2"
        points="156.7 200.6 156.7 226.5 149.6 225.6 149.6 199.7 156.7 200.6"
      />
      <polygon
        className="st2"
        points="161.5 195.6 161.5 221.5 156.7 226.5 156.7 200.6 161.5 195.6"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="57.2 786.3 57.2 812.1 54.5 828.9 54.5 803 57.2 786.3"
      />
      <polygon
        className="st2"
        points="54.5 803 54.5 828.9 45.3 833.4 45.3 807.5 54.5 803"
      />
      <polygon
        className="st2"
        points="45.3 807.5 45.3 833.4 36.8 824.4 36.8 798.6 45.3 807.5"
      />
    </g>
    <g className="st3">
      <path
        className="st2"
        d="M108.2,294.5v25.9c0,1.3,0,2.3-.2,2.6v-25.9c.2-.3.2-1.3.2-2.6Z"
      />
      <rect className="st2" x="98.2" y="297.1" width="9.8" height="25.9" />
      <polygon
        className="st2"
        points="98.2 297.1 98.2 323 95.4 311.8 95.4 285.9 98.2 297.1"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="101.8 307.8 101.8 333.7 95.4 339.4 95.4 313.5 101.8 307.8"
      />
      <polygon
        className="st2"
        points="95.4 313.5 95.4 339.4 91 335.4 91 309.5 95.4 313.5"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="95.4 325.7 95.4 351.6 85.4 357.3 85.4 331.4 95.4 325.7"
      />
      <polygon
        className="st2"
        points="85.4 331.4 85.4 357.3 82.3 353.8 82.3 327.9 85.4 331.4"
      />
    </g>
    <g className="st3">
      <rect className="st2" x="314.4" y="73.5" width="11.5" height="25.9" />
      <polygon
        className="st2"
        points="351.6 98.4 351.6 124.3 348.5 115.8 348.5 89.9 351.6 98.4"
      />
      <polygon
        className="st2"
        points="348.5 89.9 348.5 115.8 336.1 124.3 336.1 98.4 348.5 89.9"
      />
      <polygon
        className="st2"
        points="336.1 98.4 336.1 124.3 325.9 116.8 325.9 90.9 336.1 98.4"
      />
      <polygon
        className="st2"
        points="249.7 104.7 249.7 130.6 242.8 114.6 242.8 88.7 249.7 104.7"
      />
      <polygon
        className="st2"
        points="263.6 102.8 263.6 128.7 249.7 130.6 249.7 104.7 263.6 102.8"
      />
      <polygon
        className="st2"
        points="351.6 98.4 351.6 124.3 347.5 131.2 347.5 105.3 351.6 98.4"
      />
      <rect className="st2" x="362.4" y="108.8" width="17" height="25.9" />
      <polygon
        className="st2"
        points="271 112.2 271 138 263.6 128.7 263.6 102.8 271 112.2"
      />
      <polygon
        className="st2"
        points="355.7 115.3 355.7 141.2 347.5 131.2 347.5 105.3 355.7 115.3"
      />
      <polygon
        className="st2"
        points="362.4 108.8 362.4 134.7 355.7 141.2 355.7 115.3 362.4 108.8"
      />
      <rect className="st2" x="379.4" y="132.7" width="13.4" height="25.9" />
      <polygon
        className="st2"
        points="257.5 139.7 257.5 165.6 252 153.7 252 127.8 257.5 139.7"
      />
      <polygon
        className="st2"
        points="247.4 133.4 247.4 159.3 243.6 166.7 243.6 140.9 247.4 133.4"
      />
      <polygon
        className="st2"
        points="231.6 142.7 231.6 168.6 219.6 165.6 219.6 139.7 231.6 142.7"
      />
      <polygon
        className="st2"
        points="408.7 151.1 408.7 176.9 392.7 158.5 392.7 132.7 408.7 151.1"
      />
      <polygon
        className="st2"
        points="238.5 155 238.5 180.9 231.6 168.6 231.6 142.7 238.5 155"
      />
      <polygon
        className="st2"
        points="229.3 168.4 229.3 194.3 225.8 187.2 225.8 161.4 229.3 168.4"
      />
      <polygon
        className="st2"
        points="408.7 164 408.7 189.9 390.1 200.3 390.1 174.4 408.7 164"
      />
      <polygon
        className="st2"
        points="168.7 193 168.7 218.9 162.5 210.5 162.5 184.6 168.7 193"
      />
      <polygon
        className="st2"
        points="390.1 195.8 390.1 221.6 382.4 227.6 382.4 201.7 390.1 195.8"
      />
      <rect className="st2" x="284.5" y="202" width="15.4" height="25.9" />
      <polygon
        className="st2"
        points="391.2 204.2 391.2 230.1 382.4 227.6 382.4 201.7 391.2 204.2"
      />
      <rect className="st2" x="210.4" y="207.9" width="7.3" height="25.9" />
      <polygon
        className="st2"
        points="191.1 207.9 191.1 233.8 186.8 237.9 186.8 212 191.1 207.9"
      />
      <polygon
        className="st2"
        points="284.5 202 284.5 227.9 274 239 274 213.1 284.5 202"
      />
      <polygon
        className="st2"
        points="274 213.1 274 239 268.6 233.8 268.6 207.9 274 213.1"
      />
      <polygon
        className="st2"
        points="304.1 213.3 304.1 239.2 299.9 227.9 299.9 202 304.1 213.3"
      />
      <polygon
        className="st2"
        points="174.5 213.9 174.5 239.8 162.5 230.1 162.5 204.2 174.5 213.9"
      />
      <polygon
        className="st2"
        points="186.8 212 186.8 237.9 174.5 239.8 174.5 213.9 186.8 212"
      />
      <polygon
        className="st2"
        points="223.9 217.6 223.9 243.5 217.7 233.8 217.7 207.9 223.9 217.6"
      />
      <polygon
        className="st2"
        points="210.4 207.9 210.4 233.8 203.1 243.5 203.1 217.6 210.4 207.9"
      />
      <polygon
        className="st2"
        points="203.1 217.6 203.1 243.5 196.5 231.9 196.5 206.1 203.1 217.6"
      />
      <polygon
        className="st2"
        points="237 220.9 237 246.7 223.9 243.5 223.9 217.6 237 220.9"
      />
      <polygon
        className="st2"
        points="245.1 218.4 245.1 244.2 237 246.7 237 220.9 245.1 218.4"
      />
      <polygon
        className="st2"
        points="391.2 204.2 391.2 230.1 390.7 250.5 390.7 224.6 391.2 204.2"
      />
      <rect className="st2" x="390.7" y="224.6" width="13.4" height="25.9" />
      <rect className="st2" x="249.7" y="224.7" width="7.7" height="25.9" />
      <polygon
        className="st2"
        points="249.7 224.7 249.7 250.6 245.1 244.2 245.1 218.4 249.7 224.7"
      />
      <polygon
        className="st2"
        points="268.6 207.9 268.6 233.8 257.5 250.6 257.5 224.7 268.6 207.9"
      />
      <polygon
        className="st2"
        points="304.1 224.7 304.1 250.6 299.9 254.7 299.9 228.8 304.1 224.7"
      />
      <polygon
        className="st2"
        points="165.1 225.6 165.1 251.5 160.5 256.7 160.5 230.8 165.1 225.6"
      />
      <polygon
        className="st2"
        points="152.2 230.8 152.2 256.7 147.4 251.5 147.4 225.6 152.2 230.8"
      />
      <rect className="st2" x="152.2" y="230.8" width="8.2" height="25.9" />
      <polygon
        className="st2"
        points="237 220.9 237 246.7 233.9 258.2 233.9 232.3 237 220.9"
      />
      <rect className="st2" x="233.9" y="232.3" width="6.6" height="25.9" />
      <polygon
        className="st2"
        points="310.7 229.9 310.7 255.8 304.1 259.9 304.1 234 310.7 229.9"
      />
      <polygon
        className="st2"
        points="304.1 234 304.1 259.9 299.9 254.7 299.9 228.8 304.1 234"
      />
      <polygon
        className="st2"
        points="317.2 235.5 317.2 261.4 310.7 255.8 310.7 229.9 317.2 235.5"
      />
      <polygon
        className="st2"
        points="243.6 237 243.6 262.9 240.5 258.2 240.5 232.3 243.6 237"
      />
      <polygon
        className="st2"
        points="421.4 237 421.4 262.9 404 250.5 404 224.6 421.4 237"
      />
      <polygon
        className="st2"
        points="232.8 238.9 232.8 264.7 225.8 264.4 225.8 238.5 232.8 238.9"
      />
      <polygon
        className="st2"
        points="233.9 232.3 233.9 258.2 232.8 264.7 232.8 238.9 233.9 232.3"
      />
      <polygon
        className="st2"
        points="439.5 240 439.5 265.9 421.4 262.9 421.4 237 439.5 240"
      />
      <polygon
        className="st2"
        points="317.2 235.5 317.2 261.4 309.9 265.9 309.9 240 317.2 235.5"
      />
      <polygon
        className="st2"
        points="199.8 241 199.8 266.9 191.1 268.8 191.1 243 199.8 241"
      />
      <polygon
        className="st2"
        points="446.7 245.9 446.7 271.8 439.5 265.9 439.5 240 446.7 245.9"
      />
      <polygon
        className="st2"
        points="205.8 247.4 205.8 273.3 203.1 243.5 203.1 217.6 205.8 247.4"
      />
      <polygon
        className="st2"
        points="243.6 237 243.6 262.9 243.2 273.3 243.2 247.4 243.6 237"
      />
      <polygon
        className="st2"
        points="251.3 247.1 251.3 272.9 243.2 273.3 243.2 247.4 251.3 247.1"
      />
      <polygon
        className="st2"
        points="232 249.3 232 275.2 225.8 271.5 225.8 245.6 232 249.3"
      />
      <polygon
        className="st2"
        points="309.9 240 309.9 265.9 308.8 275.2 308.8 249.3 309.9 240"
      />
      <polygon
        className="st2"
        points="446.7 245.9 446.7 271.8 443.6 278.3 443.6 252.4 446.7 245.9"
      />
      <polygon
        className="st2"
        points="191.1 243 191.1 268.8 176.8 279 176.8 253.1 191.1 243"
      />
      <polygon
        className="st2"
        points="169.5 253.1 169.5 279 159.4 266.9 159.4 241 169.5 253.1"
      />
      <rect className="st2" x="169.5" y="253.1" width="7.3" height="25.9" />
      <polygon
        className="st2"
        points="308.8 249.3 308.8 275.2 304.5 279.6 304.5 253.8 308.8 249.3"
      />
      <polygon
        className="st2"
        points="443.6 252.4 443.6 278.3 428.2 282.3 428.2 256.4 443.6 252.4"
      />
      <polygon
        className="st2"
        points="233.1 257.9 233.1 283.7 232 275.2 232 249.3 233.1 257.9"
      />
      <polygon
        className="st2"
        points="266.3 260.8 266.3 286.7 251.3 272.9 251.3 247.1 266.3 260.8"
      />
      <polygon
        className="st2"
        points="280.2 255.2 280.2 281.1 266.3 286.7 266.3 260.8 280.2 255.2"
      />
      <polygon
        className="st2"
        points="428.7 261.8 428.7 287.7 428.2 282.3 428.2 256.4 428.7 261.8"
      />
      <rect className="st2" x="285.2" y="262.7" width="8.9" height="25.9" />
      <polygon
        className="st2"
        points="304.5 253.8 304.5 279.6 294.1 288.6 294.1 262.7 304.5 253.8"
      />
      <polygon
        className="st2"
        points="285.2 262.7 285.2 288.6 280.2 281.1 280.2 255.2 285.2 262.7"
      />
      <polygon
        className="st2"
        points="233.1 257.9 233.1 283.7 224.6 292.3 224.6 266.4 233.1 257.9"
      />
      <polygon
        className="st2"
        points="217.7 266.8 217.7 292.7 205.8 273.3 205.8 247.4 217.7 266.8"
      />
      <polygon
        className="st2"
        points="224.6 266.4 224.6 292.3 217.7 292.7 217.7 266.8 224.6 266.4"
      />
      <polygon
        className="st2"
        points="437 270.3 437 296.2 428.7 287.7 428.7 261.8 437 270.3"
      />
      <polygon
        className="st2"
        points="437 270.3 437 296.2 426.2 316 426.2 290.2 437 270.3"
      />
      <polygon
        className="st2"
        points="229.7 290.7 229.7 316.5 217.7 304.2 217.7 278.4 229.7 290.7"
      />
      <polygon
        className="st2"
        points="203.4 305.9 203.4 331.8 186.8 332.2 186.8 306.3 203.4 305.9"
      />
      <polygon
        className="st2"
        points="204.6 316.4 204.6 342.2 203.4 331.8 203.4 305.9 204.6 316.4"
      />
      <rect className="st2" x="459.6" y="320.5" width="17" height="25.9" />
      <polygon
        className="st2"
        points="459.6 320.5 459.6 346.4 453.9 351.3 453.9 325.4 459.6 320.5"
      />
      <polygon
        className="st2"
        points="238.9 328.3 238.9 354.2 234.7 346 234.7 320.1 238.9 328.3"
      />
      <polygon
        className="st2"
        points="234.7 320.1 234.7 346 219.2 354.5 219.2 328.7 234.7 320.1"
      />
      <polygon
        className="st2"
        points="210.4 329 210.4 354.9 204.6 342.2 204.6 316.4 210.4 329"
      />
      <polygon
        className="st2"
        points="219.2 328.7 219.2 354.5 210.4 354.9 210.4 329 219.2 328.7"
      />
      <polygon
        className="st2"
        points="426.2 290.2 426.2 316 419.3 355.8 419.3 329.9 426.2 290.2"
      />
      <polygon
        className="st2"
        points="534.7 330.9 534.7 356.8 513.1 350.3 513.1 324.4 534.7 330.9"
      />
      <polygon
        className="st2"
        points="456.5 335.6 456.5 361.5 453.9 351.3 453.9 325.4 456.5 335.6"
      />
      <rect className="st2" x="476.6" y="335.9" width="8.2" height="25.9" />
      <polygon
        className="st2"
        points="513.1 324.4 513.1 350.3 484.8 361.8 484.8 335.9 513.1 324.4"
      />
      <polygon
        className="st2"
        points="537.8 338.4 537.8 364.2 534.7 356.8 534.7 330.9 537.8 338.4"
      />
      <rect className="st2" x="397.9" y="339.9" width="11.8" height="25.9" />
      <polygon
        className="st2"
        points="419.3 329.9 419.3 355.8 409.7 365.7 409.7 339.9 419.3 329.9"
      />
      <polygon
        className="st2"
        points="456.5 335.6 456.5 361.5 453.9 367.2 453.9 341.3 456.5 335.6"
      />
      <rect className="st2" x="427.2" y="341.3" width="26.8" height="25.9" />
      <polygon
        className="st2"
        points="427.2 341.3 427.2 367.2 419.3 355.8 419.3 329.9 427.2 341.3"
      />
      <polygon
        className="st2"
        points="537.8 338.4 537.8 364.2 521.3 370.7 521.3 344.8 537.8 338.4"
      />
      <polygon
        className="st2"
        points="542.4 345.3 542.4 371.2 528 378.1 528 352.3 542.4 345.3"
      />
      <polygon
        className="st2"
        points="528 352.3 528 378.1 521.3 370.7 521.3 344.8 528 352.3"
      />
      <polygon
        className="st2"
        points="172.2 355.9 172.2 381.8 167.2 371.3 167.2 345.4 172.2 355.9"
      />
      <polygon
        className="st2"
        points="378.3 358.7 378.3 384.6 369.1 380.6 369.1 354.8 378.3 358.7"
      />
      <polygon
        className="st2"
        points="397.9 351.8 397.9 377.6 378.3 384.6 378.3 358.7 397.9 351.8"
      />
      <polygon
        className="st2"
        points="553.7 359.2 553.7 385.1 542.4 371.2 542.4 345.3 553.7 359.2"
      />
      <rect className="st2" x="553.7" y="359.2" width="18.5" height="25.9" />
      <polygon
        className="st2"
        points="234.3 361.5 234.3 387.3 225 378 225 352.1 234.3 361.5"
      />
      <polygon
        className="st2"
        points="152.1 371.1 152.1 397 142.1 391.1 142.1 365.2 152.1 371.1"
      />
      <polygon
        className="st2"
        points="737.3 363 737.3 388.8 715.2 399.5 715.2 373.6 737.3 363"
      />
      <polygon
        className="st2"
        points="303.2 372.6 303.2 398.5 289.3 400 289.3 374.1 303.2 372.6"
      />
      <polygon
        className="st2"
        points="631.4 368.7 631.4 394.5 619 400 619 374.1 631.4 368.7"
      />
      <polygon
        className="st2"
        points="596.4 374.6 596.4 400.5 572.2 385.1 572.2 359.2 596.4 374.6"
      />
      <polygon
        className="st2"
        points="675.1 377.1 675.1 403 653 397 653 371.1 675.1 377.1"
      />
      <polygon
        className="st2"
        points="685.9 372.1 685.9 398 675.1 403 675.1 377.1 685.9 372.1"
      />
      <polygon
        className="st2"
        points="653 371.1 653 397 646.8 403.5 646.8 377.6 653 371.1"
      />
      <polygon
        className="st2"
        points="596.4 374.6 596.4 400.5 580.5 405 580.5 379.1 596.4 374.6"
      />
      <polygon
        className="st2"
        points="152.5 379.3 152.5 405.2 152.1 397 152.1 371.1 152.5 379.3"
      />
      <polygon
        className="st2"
        points="615.5 382.1 615.5 408 596.4 400.5 596.4 374.6 615.5 382.1"
      />
      <polygon
        className="st2"
        points="289.3 374.1 289.3 400 284.7 408 284.7 382.1 289.3 374.1"
      />
      <polygon
        className="st2"
        points="639.6 382.1 639.6 408 631.4 394.5 631.4 368.7 639.6 382.1"
      />
      <polygon
        className="st2"
        points="646.8 377.6 646.8 403.5 639.6 408 639.6 382.1 646.8 377.6"
      />
      <polygon
        className="st2"
        points="619 374.1 619 400 615.5 408 615.5 382.1 619 374.1"
      />
      <polygon
        className="st2"
        points="284.7 382.1 284.7 408 254 408.6 254 382.7 284.7 382.1"
      />
      <polygon
        className="st2"
        points="254 382.7 254 408.6 234.3 387.3 234.3 361.5 254 382.7"
      />
      <polygon
        className="st2"
        points="704.9 386 704.9 411.9 685.9 398 685.9 372.1 704.9 386"
      />
      <polygon
        className="st2"
        points="715.2 373.6 715.2 399.5 704.9 411.9 704.9 386 715.2 373.6"
      />
      <polygon
        className="st2"
        points="369.1 354.8 369.1 380.6 327.9 412.4 327.9 386.5 369.1 354.8"
      />
      <polygon
        className="st2"
        points="134.4 366.7 134.4 392.6 134 413.4 134 387.5 134.4 366.7"
      />
      <polygon
        className="st2"
        points="327.9 386.5 327.9 412.4 324.3 420.9 324.3 395 327.9 386.5"
      />
      <polygon
        className="st2"
        points="324.3 395 324.3 420.9 303.2 398.5 303.2 372.6 324.3 395"
      />
      <polygon
        className="st2"
        points="580.5 379.1 580.5 405 555.3 424.9 555.3 399 580.5 379.1"
      />
      <rect className="st2" x="99.3" y="410.6" width="6.2" height="25.9" />
      <polygon
        className="st2"
        points="334.6 410.9 334.6 436.8 324.3 420.9 324.3 395 334.6 410.9"
      />
      <polygon
        className="st2"
        points="341.8 414.9 341.8 440.8 334.6 436.8 334.6 410.9 341.8 414.9"
      />
      <polygon
        className="st2"
        points="94.6 415.1 94.6 441 90 435 90 409.1 94.6 415.1"
      />
      <polygon
        className="st2"
        points="99.3 410.6 99.3 436.5 94.6 441 94.6 415.1 99.3 410.6"
      />
      <polygon
        className="st2"
        points="555.3 399 555.3 424.9 551.7 445.2 551.7 419.3 555.3 399"
      />
      <rect className="st2" x="99.3" y="425.2" width="8.1" height="25.9" />
      <polygon
        className="st2"
        points="118.2 419.2 118.2 445.1 107.4 451.1 107.4 425.2 118.2 419.2"
      />
      <polygon
        className="st2"
        points="501.8 425.3 501.8 451.2 487.4 445.7 487.4 419.8 501.8 425.3"
      />
      <polygon
        className="st2"
        points="515.1 414.9 515.1 440.8 501.8 451.2 501.8 425.3 515.1 414.9"
      />
      <polygon
        className="st2"
        points="350.4 425.8 350.4 451.7 341.8 440.8 341.8 414.9 350.4 425.8"
      />
      <polygon
        className="st2"
        points="484.8 426.8 484.8 452.7 477.6 451.2 477.6 425.3 484.8 426.8"
      />
      <polygon
        className="st2"
        points="487.4 419.8 487.4 445.7 484.8 452.7 484.8 426.8 487.4 419.8"
      />
      <rect className="st2" x="291.9" y="428.3" width="12.9" height="25.9" />
      <rect className="st2" x="534.2" y="429.8" width="14.9" height="25.9" />
      <polygon
        className="st2"
        points="551.7 419.3 551.7 445.2 549.1 455.6 549.1 429.8 551.7 419.3"
      />
      <polygon
        className="st2"
        points="534.2 429.8 534.2 455.6 515.1 440.8 515.1 414.9 534.2 429.8"
      />
      <polygon
        className="st2"
        points="477.6 425.3 477.6 451.2 468.3 455.6 468.3 429.8 477.6 425.3"
      />
      <polygon
        className="st2"
        points="342.8 432.3 342.8 458.1 337.3 453.2 337.3 427.3 342.8 432.3"
      />
      <polygon
        className="st2"
        points="350.4 425.8 350.4 451.7 342.8 458.1 342.8 432.3 350.4 425.8"
      />
      <polygon
        className="st2"
        points="291.9 428.3 291.9 454.2 288.3 460.1 288.3 434.2 291.9 428.3"
      />
      <polygon
        className="st2"
        points="337.3 427.3 337.3 453.2 320.2 464.6 320.2 438.7 337.3 427.3"
      />
      <rect className="st2" x="312" y="438.7" width="8.2" height="25.9" />
      <polygon
        className="st2"
        points="312 438.7 312 464.6 304.8 454.2 304.8 428.3 312 438.7"
      />
      <polygon
        className="st2"
        points="159.1 439.3 159.1 465.2 154.4 464.1 154.4 438.2 159.1 439.3"
      />
      <rect className="st2" x="142.9" y="444.2" width="6.9" height="25.9" />
      <polygon
        className="st2"
        points="154.4 438.2 154.4 464.1 149.8 470.1 149.8 444.2 154.4 438.2"
      />
      <polygon
        className="st2"
        points="142.9 444.2 142.9 470.1 135.9 463.4 135.9 437.5 142.9 444.2"
      />
      <rect className="st2" x="121.3" y="445.7" width="7.7" height="25.9" />
      <polygon
        className="st2"
        points="121.3 445.7 121.3 471.5 118.2 445.1 118.2 419.2 121.3 445.7"
      />
      <polygon
        className="st2"
        points="135.9 437.5 135.9 463.4 129 471.5 129 445.7 135.9 437.5"
      />
      <polygon
        className="st2"
        points="475 446.2 475 472 468.3 455.6 468.3 429.8 475 446.2"
      />
      <polygon
        className="st2"
        points="475 446.2 475 472 457 468.1 457 442.2 475 446.2"
      />
      <polygon
        className="st2"
        points="457 442.2 457 468.1 439 478 439 452.1 457 442.2"
      />
      <polygon
        className="st2"
        points="446.7 462.1 446.7 488 439 478 439 452.1 446.7 462.1"
      />
      <polygon
        className="st2"
        points="299.1 464.1 299.1 489.9 288.3 479 288.3 453.1 299.1 464.1"
      />
      <polygon
        className="st2"
        points="320.2 438.7 320.2 464.6 319.3 493.9 319.3 468 320.2 438.7"
      />
      <polygon
        className="st2"
        points="432.9 462.6 432.9 488.5 421.4 495.9 421.4 470 432.9 462.6"
      />
      <polygon
        className="st2"
        points="446.7 470 446.7 495.9 432.9 488.5 432.9 462.6 446.7 470"
      />
      <polygon
        className="st2"
        points="331.5 478.5 331.5 504.4 319.3 493.9 319.3 468 331.5 478.5"
      />
      <polygon
        className="st2"
        points="331.5 478.5 331.5 504.4 329.3 513.2 329.3 487.4 331.5 478.5"
      />
      <polygon
        className="st2"
        points="436.5 490.4 436.5 516.3 421.4 495.9 421.4 470 436.5 490.4"
      />
      <polygon
        className="st2"
        points="140.2 490.6 140.2 516.5 128.3 508.6 128.3 482.7 140.2 490.6"
      />
      <rect className="st2" x="140.2" y="490.6" width="7.5" height="25.9" />
      <polygon
        className="st2"
        points="303.2 492.9 303.2 518.8 299.1 489.9 299.1 464.1 303.2 492.9"
      />
      <polygon
        className="st2"
        points="757.4 457.6 757.4 483.5 742.8 521.5 742.8 495.6 757.4 457.6"
      />
      <polygon
        className="st2"
        points="329.3 487.4 329.3 513.2 326.4 524.7 326.4 498.8 329.3 487.4"
      />
      <polygon
        className="st2"
        points="341.8 500.3 341.8 526.2 329.3 513.2 329.3 487.4 341.8 500.3"
      />
      <polygon
        className="st2"
        points="359.3 503.3 359.3 529.2 341.8 526.2 341.8 500.3 359.3 503.3"
      />
      <polygon
        className="st2"
        points="326.4 498.8 326.4 524.7 313 529.2 313 503.3 326.4 498.8"
      />
      <polygon
        className="st2"
        points="313 503.3 313 529.2 303.2 518.8 303.2 492.9 313 503.3"
      />
      <polygon
        className="st2"
        points="146.6 496.4 147.6 502.3 140.8 508.3 135 502.1 135 496.4 146.6 496.4"
      />
      <polygon
        className="st2"
        points="140.8 508.3 140.8 534.2 135 528 135 502.1 140.8 508.3"
      />
      <polygon
        className="st2"
        points="147.6 502.3 147.6 528.2 140.8 534.2 140.8 508.3 147.6 502.3"
      />
      <polygon
        className="st2"
        points="166.4 509 166.4 534.9 156.4 523 156.4 497.1 166.4 509"
      />
      <polygon
        className="st2"
        points="364.9 512.2 364.9 538.1 359.3 529.2 359.3 503.3 364.9 512.2"
      />
      <polygon
        className="st2"
        points="124.5 516.7 124.5 542.6 120.1 537.6 120.1 511.8 124.5 516.7"
      />
      <polygon
        className="st2"
        points="131.4 513 131.4 538.9 124.5 542.6 124.5 516.7 131.4 513"
      />
      <polygon
        className="st2"
        points="436.5 490.4 436.5 516.3 430.8 547.6 430.8 521.7 436.5 490.4"
      />
      <polygon
        className="st2"
        points="313 503.3 313 529.2 309.9 549.7 309.9 523.9 313 503.3"
      />
      <polygon
        className="st2"
        points="162.1 523.9 162.1 549.7 158.3 542.7 158.3 516.8 162.1 523.9"
      />
      <polygon
        className="st2"
        points="364.9 512.2 364.9 538.1 355.7 554.5 355.7 528.7 364.9 512.2"
      />
      <polygon
        className="st2"
        points="433.4 529.6 433.4 555.5 430.8 547.6 430.8 521.7 433.4 529.6"
      />
      <polygon
        className="st2"
        points="309.9 523.9 309.9 549.7 304.2 557.5 304.2 531.6 309.9 523.9"
      />
      <polygon
        className="st2"
        points="747.4 516.5 747.4 542.3 746.6 558.8 746.6 532.9 747.4 516.5"
      />
      <polygon
        className="st2"
        points="433.4 529.6 433.4 555.5 421.4 564 421.4 538.1 433.4 529.6"
      />
      <polygon
        className="st2"
        points="423.6 545 423.6 570.9 421.4 564 421.4 538.1 423.6 545"
      />
      <rect className="st2" x="423.6" y="545" width="12.9" height="25.9" />
      <polygon
        className="st2"
        points="309.9 545.5 309.9 571.4 304.2 557.5 304.2 531.6 309.9 545.5"
      />
      <polygon
        className="st2"
        points="355.7 528.7 355.7 554.5 352.6 576.9 352.6 551 355.7 528.7"
      />
      <polygon
        className="st2"
        points="443.1 552 443.1 577.9 436.5 570.9 436.5 545 443.1 552"
      />
      <rect className="st2" x="443.1" y="552" width="15.9" height="25.9" />
      <polygon
        className="st2"
        points="746.6 532.9 746.6 558.8 732 578.9 732 553 746.6 532.9"
      />
      <polygon
        className="st2"
        points="317.2 554 317.2 579.9 309.9 571.4 309.9 545.5 317.2 554"
      />
      <polygon
        className="st2"
        points="339.7 560.4 339.7 586.3 317.2 579.9 317.2 554 339.7 560.4"
      />
      <polygon
        className="st2"
        points="164.9 560.4 164.9 586.3 150.6 585.6 150.6 559.7 164.9 560.4"
      />
      <polygon
        className="st2"
        points="371.6 560.4 371.6 586.3 352.6 576.9 352.6 551 371.6 560.4"
      />
      <polygon
        className="st2"
        points="352.6 551 352.6 576.9 339.7 586.3 339.7 560.4 352.6 551"
      />
      <polygon
        className="st2"
        points="260 567.4 260 593.3 234.3 588.8 234.3 562.9 260 567.4"
      />
      <polygon
        className="st2"
        points="462.2 570.4 462.2 596.3 459.1 577.9 459.1 552 462.2 570.4"
      />
      <rect className="st2" x="446.7" y="570.4" width="15.4" height="25.9" />
      <rect className="st2" x="313" y="578.3" width="7.2" height="25.9" />
      <polygon
        className="st2"
        points="264.1 581.3 264.1 607.2 260 593.3 260 567.4 264.1 581.3"
      />
      <polygon
        className="st2"
        points="313 578.3 313 604.2 277.5 608.2 277.5 582.3 313 578.3"
      />
      <polygon
        className="st2"
        points="277.5 582.3 277.5 608.2 264.1 607.2 264.1 581.3 277.5 582.3"
      />
      <polygon
        className="st2"
        points="180.3 582.8 180.3 608.7 164.9 586.3 164.9 560.4 180.3 582.8"
      />
      <polygon
        className="st2"
        points="234.3 562.9 234.3 588.8 219.9 609.7 219.9 583.8 234.3 562.9"
      />
      <polygon
        className="st2"
        points="211.7 590.3 211.7 616.1 201.9 615.6 201.9 589.8 211.7 590.3"
      />
      <polygon
        className="st2"
        points="219.9 583.8 219.9 609.7 211.7 616.1 211.7 590.3 219.9 583.8"
      />
      <polygon
        className="st2"
        points="374.2 594.7 374.2 620.6 371.6 586.3 371.6 560.4 374.2 594.7"
      />
      <polygon
        className="st2"
        points="732 553 732 578.9 728.1 621.4 728.1 595.5 732 553"
      />
      <polygon
        className="st2"
        points="361.3 599.2 361.3 625.1 356.2 624.6 356.2 598.7 361.3 599.2"
      />
      <polygon
        className="st2"
        points="193.4 599.6 193.4 625.5 180.3 608.7 180.3 582.8 193.4 599.6"
      />
      <polygon
        className="st2"
        points="201.9 589.8 201.9 615.6 193.4 625.5 193.4 599.6 201.9 589.8"
      />
      <polygon
        className="st2"
        points="446.7 581.8 446.7 607.7 439.5 628.1 439.5 602.2 446.7 581.8"
      />
      <polygon
        className="st2"
        points="323.8 603.2 323.8 629 320.2 604.2 320.2 578.3 323.8 603.2"
      />
      <polygon
        className="st2"
        points="402 606.2 402 632 374.2 620.6 374.2 594.7 402 606.2"
      />
      <polygon
        className="st2"
        points="415.4 603.7 415.4 629.6 402 632 402 606.2 415.4 603.7"
      />
      <polygon
        className="st2"
        points="335.3 607.7 335.3 633.5 323.8 629 323.8 603.2 335.3 607.7"
      />
      <polygon
        className="st2"
        points="167.2 607.8 167.2 633.7 154.4 632.9 154.4 607 167.2 607.8"
      />
      <polygon
        className="st2"
        points="374.2 594.7 374.2 620.6 371.6 634.5 371.6 608.6 374.2 594.7"
      />
      <polygon
        className="st2"
        points="421.4 608.6 421.4 634.5 415.4 629.6 415.4 603.7 421.4 608.6"
      />
      <polygon
        className="st2"
        points="371.6 608.6 371.6 634.5 361.3 625.1 361.3 599.2 371.6 608.6"
      />
      <polygon
        className="st2"
        points="439.5 602.2 439.5 628.1 421.4 634.5 421.4 608.6 439.5 602.2"
      />
      <polygon
        className="st2"
        points="350.4 611.6 350.4 637.5 335.3 633.5 335.3 607.7 350.4 611.6"
      />
      <polygon
        className="st2"
        points="356.2 598.7 356.2 624.6 350.4 637.5 350.4 611.6 356.2 598.7"
      />
      <polygon
        className="st2"
        points="171 612.6 171 638.5 167.2 633.7 167.2 607.8 171 612.6"
      />
      <polygon
        className="st2"
        points="423.6 615.6 423.6 641.5 421.4 634.5 421.4 608.6 423.6 615.6"
      />
      <rect className="st2" x="573.8" y="621.4" width="15" height="25.9" />
      <polygon
        className="st2"
        points="430.8 621.6 430.8 647.4 423.6 641.5 423.6 615.6 430.8 621.6"
      />
      <polygon
        className="st2"
        points="211.9 618.2 211.9 644.1 183.8 647.8 183.8 621.9 211.9 618.2"
      />
      <polygon
        className="st2"
        points="183.8 621.9 183.8 647.8 171.8 648.9 171.8 623 183.8 621.9"
      />
      <polygon
        className="st2"
        points="171.8 623 171.8 648.9 171 638.5 171 612.6 171.8 623"
      />
      <polygon
        className="st2"
        points="592.5 624.2 592.5 650 588.8 647.3 588.8 621.4 592.5 624.2"
      />
      <polygon
        className="st2"
        points="737.3 616.3 737.3 642.2 725 651.9 725 626 737.3 616.3"
      />
      <polygon
        className="st2"
        points="598.9 629 598.9 654.9 592.5 650 592.5 624.2 598.9 629"
      />
      <polygon
        className="st2"
        points="573.8 621.4 573.8 647.3 559.9 655.6 559.9 629.8 573.8 621.4"
      />
      <polygon
        className="st2"
        points="559.9 629.8 559.9 655.6 556 662.3 556 636.5 559.9 629.8"
      />
      <polygon
        className="st2"
        points="430.8 621.6 430.8 647.4 421.4 662.3 421.4 636.5 430.8 621.6"
      />
      <polygon
        className="st2"
        points="539.8 636.5 539.8 662.3 532.5 664.6 532.5 638.7 539.8 636.5"
      />
      <polygon
        className="st2"
        points="598.9 636.5 598.9 662.3 594.6 665.3 594.6 639.5 598.9 636.5"
      />
      <polygon
        className="st2"
        points="202.7 645.8 202.7 671.7 185.7 660.1 185.7 634.2 202.7 645.8"
      />
      <polygon
        className="st2"
        points="542.2 646.9 542.2 672.8 539.8 662.3 539.8 636.5 542.2 646.9"
      />
      <polygon
        className="st2"
        points="532.5 638.7 532.5 664.6 522.1 675 522.1 649.1 532.5 638.7"
      />
      <polygon
        className="st2"
        points="556 636.5 556 662.3 547.5 675.4 547.5 649.5 556 636.5"
      />
      <polygon
        className="st2"
        points="547.5 649.5 547.5 675.4 542.2 672.8 542.2 646.9 547.5 649.5"
      />
      <polygon
        className="st2"
        points="598.9 649.9 598.9 675.8 594.6 665.3 594.6 639.5 598.9 649.9"
      />
      <polygon
        className="st2"
        points="421.4 636.5 421.4 662.3 392.7 676.8 392.7 650.9 421.4 636.5"
      />
      <rect className="st2" x="453.7" y="655.3" width="9" height="25.9" />
      <rect className="st2" x="444.2" y="655.3" width="9.5" height="25.9" />
      <polygon
        className="st2"
        points="444.2 655.3 444.2 681.2 421.4 662.3 421.4 636.5 444.2 655.3"
      />
      <polygon
        className="st2"
        points="525.9 655.8 525.9 681.7 522.1 675 522.1 649.1 525.9 655.8"
      />
      <rect className="st2" x="525.9" y="655.8" width="9.3" height="25.9" />
      <polygon
        className="st2"
        points="768.2 630.5 768.2 656.4 758.2 685.5 758.2 659.6 768.2 630.5"
      />
      <polygon
        className="st2"
        points="392.7 650.9 392.7 676.8 384.5 685.7 384.5 659.8 392.7 650.9"
      />
      <polygon
        className="st2"
        points="598.9 654.3 598.9 680.2 587.7 685.8 587.7 659.9 598.9 654.3"
      />
      <polygon
        className="st2"
        points="539.8 660.3 539.8 686.2 535.2 681.7 535.2 655.8 539.8 660.3"
      />
      <polygon
        className="st2"
        points="384.5 659.8 384.5 685.7 380.2 688.9 380.2 663 384.5 659.8"
      />
      <polygon
        className="st2"
        points="380.2 663 380.2 688.9 375.2 692.7 375.2 666.8 380.2 663"
      />
      <rect className="st2" x="526.3" y="667" width="13.5" height="25.9" />
      <polygon
        className="st2"
        points="474.5 669.3 474.5 695.1 462.7 681.2 462.7 655.3 474.5 669.3"
      />
      <polygon
        className="st2"
        points="587.7 670.7 587.7 696.6 580.7 701.5 580.7 675.6 587.7 670.7"
      />
      <polygon
        className="st2"
        points="526.3 667 526.3 692.9 521.3 703.7 521.3 677.8 526.3 667"
      />
      <polygon
        className="st2"
        points="584.6 681.9 584.6 707.8 580.7 701.5 580.7 675.6 584.6 681.9"
      />
      <polygon
        className="st2"
        points="484.8 682.2 484.8 708.1 474.5 695.1 474.5 669.3 484.8 682.2"
      />
      <rect className="st2" x="555.5" y="683.8" width="5.6" height="25.9" />
      <polygon
        className="st2"
        points="136.7 686.4 136.7 712.3 136.3 701.1 136.3 675.2 136.7 686.4"
      />
      <polygon
        className="st2"
        points="530.6 689.4 530.6 715.2 521.3 703.7 521.3 677.8 530.6 689.4"
      />
      <polygon
        className="st2"
        points="142.5 691.2 142.5 717.1 136.7 712.3 136.7 686.4 142.5 691.2"
      />
      <polygon
        className="st2"
        points="567.2 692 567.2 717.9 561 709.7 561 683.8 567.2 692"
      />
      <rect className="st2" x="567.2" y="692" width="17.4" height="25.9" />
      <polygon
        className="st2"
        points="173.3 692.7 173.3 718.6 142.5 717.1 142.5 691.2 173.3 692.7"
      />
      <polygon
        className="st2"
        points="515.9 689.4 515.9 715.2 512 718.6 512 692.7 515.9 689.4"
      />
      <polygon
        className="st2"
        points="530.6 689.4 530.6 715.2 523.4 719.7 523.4 693.8 530.6 689.4"
      />
      <polygon
        className="st2"
        points="523.4 693.8 523.4 719.7 515.9 715.2 515.9 689.4 523.4 693.8"
      />
      <polygon
        className="st2"
        points="555.5 683.8 555.5 709.7 548.1 722.5 548.1 696.6 555.5 683.8"
      />
      <polygon
        className="st2"
        points="484.8 690.1 484.8 716 474.5 723 474.5 697.1 484.8 690.1"
      />
      <polygon
        className="st2"
        points="173.7 698.3 173.7 724.2 173.3 718.6 173.3 692.7 173.7 698.3"
      />
      <polygon
        className="st2"
        points="695.2 701.5 695.2 727.4 673.6 722.5 673.6 696.6 695.2 701.5"
      />
      <polygon
        className="st2"
        points="480.2 702 480.2 727.9 474.5 723 474.5 697.1 480.2 702"
      />
      <polygon
        className="st2"
        points="506.9 705 506.9 730.9 480.2 727.9 480.2 702 506.9 705"
      />
      <polygon
        className="st2"
        points="673.6 696.6 673.6 722.5 658.1 731.4 658.1 705.5 673.6 696.6"
      />
      <polygon
        className="st2"
        points="548.1 696.6 548.1 722.5 538.8 733.9 538.8 708 548.1 696.6"
      />
      <polygon
        className="st2"
        points="375.2 666.8 375.2 692.7 358.3 734.9 358.3 709 375.2 666.8"
      />
      <polygon
        className="st2"
        points="538.8 708 538.8 733.9 523.4 736.4 523.4 710.5 538.8 708"
      />
      <polygon
        className="st2"
        points="523.4 710.5 523.4 736.4 512 718.6 512 692.7 523.4 710.5"
      />
      <rect className="st2" x="695.2" y="715.5" width="11.3" height="25.9" />
      <polygon
        className="st2"
        points="718.3 710 718.3 735.9 706.5 741.3 706.5 715.5 718.3 710"
      />
      <polygon
        className="st2"
        points="514.1 715.5 514.1 741.3 506.9 730.9 506.9 705 514.1 715.5"
      />
      <rect className="st2" x="621.1" y="715.5" width="29.3" height="25.9" />
      <rect className="st2" x="650.4" y="715.5" width="7.7" height="25.9" />
      <polygon
        className="st2"
        points="553.2 715.5 553.2 741.3 548.1 722.5 548.1 696.6 553.2 715.5"
      />
      <polygon
        className="st2"
        points="523.4 710.5 523.4 736.4 514.1 741.3 514.1 715.5 523.4 710.5"
      />
      <polygon
        className="st2"
        points="738.9 719.2 738.9 745.1 718.3 735.9 718.3 710 738.9 719.2"
      />
      <polygon
        className="st2"
        points="758.2 659.6 758.2 685.5 738.9 745.1 738.9 719.2 758.2 659.6"
      />
      <polygon
        className="st2"
        points="202.4 715.5 202.4 741.3 189 746.8 189 720.9 202.4 715.5"
      />
      <polygon
        className="st2"
        points="560.4 722.4 560.4 748.3 553.2 741.3 553.2 715.5 560.4 722.4"
      />
      <polygon
        className="st2"
        points="570.7 718.4 570.7 744.3 560.4 748.3 560.4 722.4 570.7 718.4"
      />
      <polygon
        className="st2"
        points="189 720.9 189 746.8 180.8 750.8 180.8 724.9 189 720.9"
      />
      <polygon
        className="st2"
        points="213.2 725.4 213.2 751.3 202.4 741.3 202.4 715.5 213.2 725.4"
      />
      <polygon
        className="st2"
        points="367.5 725.4 367.5 751.3 358.3 742.8 358.3 717 367.5 725.4"
      />
      <rect className="st2" x="121.2" y="726.4" width="11.8" height="25.9" />
      <polygon
        className="st2"
        points="621.1 715.5 621.1 741.3 602.6 753.3 602.6 727.4 621.1 715.5"
      />
      <rect className="st2" x="591.8" y="727.4" width="10.8" height="25.9" />
      <polygon
        className="st2"
        points="591.8 727.4 591.8 753.3 570.7 744.3 570.7 718.4 591.8 727.4"
      />
      <polygon
        className="st2"
        points="241 722.9 241 748.8 228.6 756.8 228.6 730.9 241 722.9"
      />
      <polygon
        className="st2"
        points="650.4 725.4 650.4 751.3 639.1 757.2 639.1 731.4 650.4 725.4"
      />
      <polygon
        className="st2"
        points="247.2 732.3 247.2 758.2 241 748.8 241 722.9 247.2 732.3"
      />
      <polygon
        className="st2"
        points="133 726.4 133 752.3 129.9 762.2 129.9 736.3 133 726.4"
      />
      <polygon
        className="st2"
        points="118.6 738.2 118.6 764.1 118.2 755.5 118.2 729.6 118.6 738.2"
      />
      <polygon
        className="st2"
        points="217.3 740.3 217.3 766.2 213.2 751.3 213.2 725.4 217.3 740.3"
      />
      <polygon
        className="st2"
        points="247.2 732.3 247.2 758.2 242 767.1 242 741.2 247.2 732.3"
      />
      <polygon
        className="st2"
        points="738.9 719.2 738.9 745.1 736.6 768.9 736.6 743 738.9 719.2"
      />
      <polygon
        className="st2"
        points="228.6 744.3 228.6 770.2 217.3 766.2 217.3 740.3 228.6 744.3"
      />
      <polygon
        className="st2"
        points="369.1 746.3 369.1 772.1 367.5 751.3 367.5 725.4 369.1 746.3"
      />
      <polygon
        className="st2"
        points="656.6 747.3 656.6 773.1 639.1 766.7 639.1 740.8 656.6 747.3"
      />
      <polygon
        className="st2"
        points="247.2 749.7 247.2 775.6 242 767.1 242 741.2 247.2 749.7"
      />
      <polygon
        className="st2"
        points="180.8 740.8 180.8 766.7 157.6 780.6 157.6 754.7 180.8 740.8"
      />
      <polygon
        className="st2"
        points="369.1 746.3 369.1 772.1 355.2 780.6 355.2 754.7 369.1 746.3"
      />
      <polygon
        className="st2"
        points="157.6 754.7 157.6 780.6 148.9 776.1 148.9 750.2 157.6 754.7"
      />
      <polygon
        className="st2"
        points="148.9 750.2 148.9 776.1 140.7 781.6 140.7 755.7 148.9 750.2"
      />
      <polygon
        className="st2"
        points="140.7 755.7 140.7 781.6 129.9 762.2 129.9 736.3 140.7 755.7"
      />
      <polygon
        className="st2"
        points="247.2 749.7 247.2 775.6 241 782.6 241 756.7 247.2 749.7"
      />
      <polygon
        className="st2"
        points="340.2 760.2 340.2 786.1 322.8 782.6 322.8 756.7 340.2 760.2"
      />
      <polygon
        className="st2"
        points="736.6 743 736.6 768.9 727.3 788.3 727.3 762.4 736.6 743"
      />
      <polygon
        className="st2"
        points="727.3 762.4 727.3 788.3 718.8 781.6 718.8 755.7 727.3 762.4"
      />
      <polygon
        className="st2"
        points="268.8 759.7 268.8 785.6 250.8 791.8 250.8 765.9 268.8 759.7"
      />
      <polygon
        className="st2"
        points="250.8 765.9 250.8 791.8 241 782.6 241 756.7 250.8 765.9"
      />
      <polygon
        className="st2"
        points="681.3 767.6 681.3 793.5 656.6 773.1 656.6 747.3 681.3 767.6"
      />
      <polygon
        className="st2"
        points="718.8 755.7 718.8 781.6 711.1 795 711.1 769.1 718.8 755.7"
      />
      <polygon
        className="st2"
        points="311.5 769.6 311.5 795.5 268.8 785.6 268.8 759.7 311.5 769.6"
      />
      <polygon
        className="st2"
        points="322.8 756.7 322.8 782.6 311.5 795.5 311.5 769.6 322.8 756.7"
      />
      <polygon
        className="st2"
        points="355.2 763.7 355.2 789.5 352.6 801 352.6 775.1 355.2 763.7"
      />
      <polygon
        className="st2"
        points="352.6 775.1 352.6 801 340.2 786.1 340.2 760.2 352.6 775.1"
      />
      <rect className="st2" x="681.3" y="778.6" width="12.9" height="25.9" />
      <polygon
        className="st2"
        points="103.9 780.7 103.9 806.5 91.2 799.5 91.2 773.6 103.9 780.7"
      />
      <polygon
        className="st2"
        points="701.1 796 701.1 821.8 694.1 804.4 694.1 778.6 701.1 796"
      />
      <polygon
        className="st2"
        points="712.7 787.8 712.7 813.6 701.1 821.8 701.1 796 712.7 787.8"
      />
      <polygon
        className="st2"
        points="681.3 778.6 681.3 804.4 654 823.3 654 797.4 681.3 778.6"
      />
      <rect className="st2" x="639.1" y="797.4" width="14.9" height="25.9" />
      <polygon
        className="st2"
        points="355.7 804.4 355.7 830.3 352.6 801 352.6 775.1 355.7 804.4"
      />
      <polygon
        className="st2"
        points="121.3 806.8 121.3 832.6 103.1 812.1 103.1 786.3 121.3 806.8"
      />
      <polygon
        className="st2"
        points="701.1 796 701.1 821.8 686.4 835.7 686.4 809.9 701.1 796"
      />
      <polygon
        className="st2"
        points="639.1 797.4 639.1 823.3 633.5 836.7 633.5 810.8 639.1 797.4"
      />
      <rect className="st2" x="611.3" y="810.8" width="22.1" height="25.9" />
      <polygon
        className="st2"
        points="369.1 811.3 369.1 837.2 355.7 830.3 355.7 804.4 369.1 811.3"
      />
      <polygon
        className="st2"
        points="99.3 801.9 99.3 827.8 78.4 844.2 78.4 818.3 99.3 801.9"
      />
      <polygon
        className="st2"
        points="96.2 817.2 96.2 843.1 95.8 835.6 95.8 809.7 96.2 817.2"
      />
      <polygon
        className="st2"
        points="78.4 818.3 78.4 844.2 61.1 827.8 61.1 801.9 78.4 818.3"
      />
      <polygon
        className="st2"
        points="99.7 822 99.7 847.9 96.2 843.1 96.2 817.2 99.7 822"
      />
      <polygon
        className="st2"
        points="611.3 810.8 611.3 836.7 605.7 848.2 605.7 822.3 611.3 810.8"
      />
      <rect className="st2" x="592.5" y="822.3" width="13.2" height="25.9" />
      <polygon
        className="st2"
        points="61.1 825 61.1 850.9 52.6 839.3 52.6 813.5 61.1 825"
      />
      <rect className="st2" x="61.1" y="825" width="6.6" height="25.9" />
      <polygon
        className="st2"
        points="52.6 822 58.4 828.2 54.1 832.5 48.5 832.5 52.6 822"
      />
      <polygon
        className="st2"
        points="58.4 828.2 58.4 854.1 54.1 858.3 54.1 832.5 58.4 828.2"
      />
      <rect className="st2" x="48.5" y="832.5" width="5.7" height="25.9" />
      <polygon
        className="st2"
        points="596.4 833.7 596.4 859.6 592.5 848.2 592.5 822.3 596.4 833.7"
      />
      <polygon
        className="st2"
        points="555.2 822.8 555.2 848.7 553.7 861.6 553.7 835.7 555.2 822.8"
      />
      <polygon
        className="st2"
        points="542.4 838.2 542.4 864.1 528.5 867 528.5 841.2 542.4 838.2"
      />
      <polygon
        className="st2"
        points="686.4 821.3 686.4 847.2 661 868.5 661 842.7 686.4 821.3"
      />
      <polygon
        className="st2"
        points="576.9 844.1 576.9 870 555.2 848.7 555.2 822.8 576.9 844.1"
      />
      <polygon
        className="st2"
        points="103.9 840.7 103.9 866.5 94.6 871 94.6 845.1 103.9 840.7"
      />
      <polygon
        className="st2"
        points="94.6 845.1 94.6 871 86.5 861.7 86.5 835.8 94.6 845.1"
      />
      <polygon
        className="st2"
        points="389.1 845.1 389.1 871 369.1 849.2 369.1 823.3 389.1 845.1"
      />
      <polygon
        className="st2"
        points="595.4 845.1 595.4 871 576.9 870 576.9 844.1 595.4 845.1"
      />
      <polygon
        className="st2"
        points="596.4 833.7 596.4 859.6 595.4 871 595.4 845.1 596.4 833.7"
      />
      <polygon
        className="st2"
        points="624.7 842.7 624.7 868.5 613.9 875.5 613.9 849.6 624.7 842.7"
      />
      <polygon
        className="st2"
        points="613.9 849.6 613.9 875.5 595.4 871 595.4 845.1 613.9 849.6"
      />
      <polygon
        className="st2"
        points="439.5 842.9 439.5 868.8 431.8 875.9 431.8 850 439.5 842.9"
      />
      <polygon
        className="st2"
        points="661 850.6 661 876.5 645.8 870.5 645.8 844.6 661 850.6"
      />
      <polygon
        className="st2"
        points="551.7 850.6 551.7 876.5 542.4 864.1 542.4 838.2 551.7 850.6"
      />
      <polygon
        className="st2"
        points="556.8 845.1 556.8 871 551.7 876.5 551.7 850.6 556.8 845.1"
      />
      <polygon
        className="st2"
        points="24.2 850.8 24.2 876.7 22.1 869.3 22.1 843.4 24.2 850.8"
      />
      <polygon
        className="st2"
        points="43.7 846.1 43.7 872 34.5 879 34.5 853.2 43.7 846.1"
      />
      <polygon
        className="st2"
        points="34.5 853.2 34.5 879 24.2 876.7 24.2 850.8 34.5 853.2"
      />
      <polygon
        className="st2"
        points="628.8 856.6 628.8 882.4 624.7 868.5 624.7 842.7 628.8 856.6"
      />
      <polygon
        className="st2"
        points="639.1 853.6 639.1 879.5 628.8 882.4 628.8 856.6 639.1 853.6"
      />
      <polygon
        className="st2"
        points="650.4 856.6 650.4 882.4 639.1 879.5 639.1 853.6 650.4 856.6"
      />
      <rect className="st2" x="421.4" y="858.2" width="10.4" height="25.9" />
      <polygon
        className="st2"
        points="421.4 858.2 421.4 884.1 416.4 882.2 416.4 856.3 421.4 858.2"
      />
      <rect className="st2" x="73" y="859.1" width="11.1" height="25.9" />
      <polygon
        className="st2"
        points="105.4 859.3 105.4 885.2 103.9 866.5 103.9 840.7 105.4 859.3"
      />
      <polygon
        className="st2"
        points="528.5 856.6 528.5 882.4 522.1 888 522.1 862.2 528.5 856.6"
      />
      <polygon
        className="st2"
        points="96.8 859.7 96.8 885.5 89.3 890.1 89.3 864.2 96.8 859.7"
      />
      <polygon
        className="st2"
        points="89.3 864.2 89.3 890.1 84 885 84 859.1 89.3 864.2"
      />
      <polygon
        className="st2"
        points="57.2 853.2 57.2 879 46 890.6 46 864.8 57.2 853.2"
      />
      <rect className="st2" x="36.8" y="864.8" width="9.3" height="25.9" />
      <polygon
        className="st2"
        points="416.4 856.3 416.4 882.2 405.6 890.8 405.6 864.9 416.4 856.3"
      />
      <polygon
        className="st2"
        points="389.1 845.1 389.1 871 367.4 894.1 367.4 868.2 389.1 845.1"
      />
      <polygon
        className="st2"
        points="405.6 864.9 405.6 890.8 386.3 891.1 386.3 865.3 405.6 864.9"
      />
      <polygon
        className="st2"
        points="522.1 862.2 522.1 888 518.2 891.4 518.2 865.5 522.1 862.2"
      />
      <polygon
        className="st2"
        points="597.2 866 597.2 891.9 595.4 877.5 595.4 851.6 597.2 866"
      />
      <polygon
        className="st2"
        points="601.6 851.6 606.2 855.6 603.1 866 597.2 866 595.4 851.6 601.6 851.6"
      />
      <rect className="st2" x="597.2" y="866" width="5.9" height="25.9" />
      <polygon
        className="st2"
        points="606.2 855.6 606.2 881.5 603.1 891.9 603.1 866 606.2 855.6"
      />
      <polygon
        className="st2"
        points="578.7 864 578.7 889.9 571 895.9 571 870 578.7 864"
      />
      <polygon
        className="st2"
        points="441.5 872.3 441.5 898.2 439.5 880.3 439.5 854.5 441.5 872.3"
      />
      <polygon
        className="st2"
        points="23.7 866 23.7 891.9 19.8 898.8 19.8 873 23.7 866"
      />
      <rect className="st2" x="12.9" y="873" width="6.9" height="25.9" />
      <polygon
        className="st2"
        points="360.4 873.5 360.4 899.3 346.5 895.2 346.5 869.4 360.4 873.5"
      />
      <polygon
        className="st2"
        points="367.4 868.2 367.4 894.1 360.4 899.3 360.4 873.5 367.4 868.2"
      />
      <polygon
        className="st2"
        points="346.5 869.4 346.5 895.2 342.7 899.7 342.7 873.8 346.5 869.4"
      />
      <rect className="st2" x="532.4" y="874.7" width="6.4" height="25.9" />
      <polygon
        className="st2"
        points="541.4 867.5 541.4 893.4 538.8 900.6 538.8 874.7 541.4 867.5"
      />
      <polygon
        className="st2"
        points="379.4 876.8 379.4 902.7 367.4 894.1 367.4 868.2 379.4 876.8"
      />
      <polygon
        className="st2"
        points="386.3 876.1 386.3 901.9 379.4 902.7 379.4 876.8 386.3 876.1"
      />
      <polygon
        className="st2"
        points="435 870 435 895.9 432.6 904.8 432.6 878.9 435 870"
      />
      <polygon
        className="st2"
        points="487 879 487 904.9 472.3 899.3 472.3 873.5 487 879"
      />
      <polygon
        className="st2"
        points="496.2 874.2 496.2 900.1 487 904.9 487 879 496.2 874.2"
      />
      <polygon
        className="st2"
        points="454.6 880.2 454.6 906 441.5 898.2 441.5 872.3 454.6 880.2"
      />
      <polygon
        className="st2"
        points="468.5 880.5 468.5 906.4 454.6 906 454.6 880.2 468.5 880.5"
      />
      <polygon
        className="st2"
        points="472.3 873.5 472.3 899.3 468.5 906.4 468.5 880.5 472.3 873.5"
      />
      <polygon
        className="st2"
        points="12.9 873 12.9 898.8 6.2 906.8 6.2 880.9 12.9 873"
      />
      <rect className="st2" y="880.9" width="6.2" height="25.9" />
      <polygon
        className="st2"
        points="416.9 875.7 416.9 901.6 410.7 907 410.7 881.2 416.9 875.7"
      />
      <polygon
        className="st2"
        points="558.1 884.6 558.1 910.5 551.9 904.3 551.9 878.4 558.1 884.6"
      />
      <rect className="st2" x="314.5" y="885" width="17.4" height="25.9" />
      <polygon
        className="st2"
        points="518.2 865.5 518.2 891.4 514.6 911.3 514.6 885.4 518.2 865.5"
      />
      <polygon
        className="st2"
        points="410.7 881.2 410.7 907 410.2 912.5 410.2 886.6 410.7 881.2"
      />
      <polygon
        className="st2"
        points="435.4 887.6 435.4 913.5 421.4 913.2 421.4 887.4 435.4 887.6"
      />
      <polygon
        className="st2"
        points="580.2 881.3 580.2 907.2 569.9 914.5 569.9 888.6 580.2 881.3"
      />
      <rect className="st2" x="98.5" y="890.2" width="14.3" height="25.9" />
      <polygon
        className="st2"
        points="98.5 890.2 98.5 916.1 93.3 911.1 93.3 885.2 98.5 890.2"
      />
      <polygon
        className="st2"
        points="505.5 890.2 505.5 916.1 495.5 918 495.5 892.1 505.5 890.2"
      />
      <polygon
        className="st2"
        points="495.5 892.1 495.5 918 487 913.5 487 887.6 495.5 892.1"
      />
      <polygon
        className="st2"
        points="440.8 892.6 440.8 918.5 435.4 913.5 435.4 887.6 440.8 892.6"
      />
      <rect className="st2" x="440.8" y="892.6" width="6.4" height="25.9" />
      <rect className="st2" x="462.9" y="892.6" width="7.5" height="25.9" />
      <polygon
        className="st2"
        points="52 892.6 52 918.5 36.8 903.3 36.8 877.4 52 892.6"
      />
      <polygon
        className="st2"
        points="60.1 884.9 60.1 910.8 52 918.5 52 892.6 60.1 884.9"
      />
      <polygon
        className="st2"
        points="314.5 885 314.5 910.9 303 921.3 303 895.4 314.5 885"
      />
      <polygon
        className="st2"
        points="506.3 896.2 506.3 922.1 505.5 916.1 505.5 890.2 506.3 896.2"
      />
      <polygon
        className="st2"
        points="339.6 897.3 339.6 923.2 331.9 917.2 331.9 891.3 339.6 897.3"
      />
      <polygon
        className="st2"
        points="10.3 899.3 10.3 925.2 2.6 919.7 2.6 893.8 10.3 899.3"
      />
      <rect className="st2" x="10.3" y="899.3" width="4.6" height="25.9" />
      <polygon
        className="st2"
        points="21 892.6 21 918.5 14.9 925.2 14.9 899.3 21 892.6"
      />
      <polygon
        className="st2"
        points="397.4 899.8 397.4 925.7 391.2 915.5 391.2 889.6 397.4 899.8"
      />
      <polygon
        className="st2"
        points="122.8 899.9 122.8 925.8 112.8 916.1 112.8 890.2 122.8 899.9"
      />
      <rect className="st2" x="470.4" y="902.3" width="10.5" height="25.9" />
      <polygon
        className="st2"
        points="585.6 895.8 585.6 921.7 574.3 928.9 574.3 903 585.6 895.8"
      />
      <polygon
        className="st2"
        points="93.5 903.3 93.5 929.2 93.1 922.8 93.1 896.9 93.5 903.3"
      />
      <polygon
        className="st2"
        points="525.2 892.1 525.2 918 516.7 929.5 516.7 903.6 525.2 892.1"
      />
      <polygon
        className="st2"
        points="548.8 903.8 548.8 929.7 545 923.3 545 897.4 548.8 903.8"
      />
      <polygon
        className="st2"
        points="88.9 891.7 88.9 917.6 87.7 930.6 87.7 904.8 88.9 891.7"
      />
      <polygon
        className="st2"
        points="287.5 905.1 287.5 931 269.4 928 269.4 902.2 287.5 905.1"
      />
      <polygon
        className="st2"
        points="417.7 905.2 417.7 931.1 412.3 929.7 412.3 903.8 417.7 905.2"
      />
      <polygon
        className="st2"
        points="545 897.4 545 923.3 539.3 931.4 539.3 905.5 545 897.4"
      />
      <rect className="st2" x="534.4" y="905.5" width="4.9" height="25.9" />
      <polygon
        className="st2"
        points="534.4 905.5 534.4 931.4 527.7 923.3 527.7 897.4 534.4 905.5"
      />
      <polygon
        className="st2"
        points="442.6 902.8 442.6 928.7 438.2 933.1 438.2 907.2 442.6 902.8"
      />
      <polygon
        className="st2"
        points="381.3 902.9 381.3 928.8 374.7 933.2 374.7 907.4 381.3 902.9"
      />
      <polygon
        className="st2"
        points="500.5 907.7 500.5 933.6 492.4 932.5 492.4 906.6 500.5 907.7"
      />
      <polygon
        className="st2"
        points="340.8 908.5 340.8 934.4 339.6 923.2 339.6 897.3 340.8 908.5"
      />
      <polygon
        className="st2"
        points="76.1 909.6 76.1 935.5 70.3 930.6 70.3 904.8 76.1 909.6"
      />
      <polygon
        className="st2"
        points="61.1 904.4 61.1 930.3 55 937.1 55 911.2 61.1 904.4"
      />
      <rect className="st2" x="45.3" y="911.2" width="9.8" height="25.9" />
      <polygon
        className="st2"
        points="45.3 911.2 45.3 937.1 39.9 932.1 39.9 906.2 45.3 911.2"
      />
      <polygon
        className="st2"
        points="102.4 913 102.4 938.8 93.5 929.2 93.5 903.3 102.4 913"
      />
      <rect className="st2" x="540.3" y="913.2" width="4.4" height="25.9" />
      <polygon
        className="st2"
        points="269.4 902.2 269.4 928 257.1 940 257.1 914.1 269.4 902.2"
      />
      <polygon
        className="st2"
        points="573.8 915 573.8 940.8 568.6 932.4 568.6 906.5 573.8 915"
      />
      <polygon
        className="st2"
        points="581.2 909.5 581.2 935.4 573.8 940.8 573.8 915 581.2 909.5"
      />
      <polygon
        className="st2"
        points="362 915.6 362 941.5 357 938.5 357 912.6 362 915.6"
      />
      <polygon
        className="st2"
        points="369.3 915.2 369.3 941.1 362 941.5 362 915.6 369.3 915.2"
      />
      <polygon
        className="st2"
        points="525 915.6 525 941.5 522.1 932.1 522.1 906.2 525 915.6"
      />
      <polygon
        className="st2"
        points="532.4 913 532.4 938.8 525 941.5 525 915.6 532.4 913"
      />
      <polygon
        className="st2"
        points="287.9 915.9 287.9 941.8 287.5 931 287.5 905.1 287.9 915.9"
      />
      <polygon
        className="st2"
        points="257.1 914.1 257.1 940 243.6 941.8 243.6 915.9 257.1 914.1"
      />
      <polygon
        className="st2"
        points="568.6 906.5 568.6 932.4 559.1 941.8 559.1 915.9 568.6 906.5"
      />
      <rect className="st2" x="398.4" y="917.4" width="8.2" height="25.9" />
      <polygon
        className="st2"
        points="412.3 903.8 412.3 929.7 406.6 943.3 406.6 917.4 412.3 903.8"
      />
      <polygon
        className="st2"
        points="398.4 917.4 398.4 943.3 393.5 934.1 393.5 908.2 398.4 917.4"
      />
      <polygon
        className="st2"
        points="29.9 918.4 29.9 944.3 27.5 933.9 27.5 908 29.9 918.4"
      />
      <rect className="st2" x="18.3" y="919.7" width="5.4" height="25.9" />
      <polygon
        className="st2"
        points="18.3 919.7 18.3 945.5 15.2 934.9 15.2 909 18.3 919.7"
      />
      <polygon
        className="st2"
        points="18.1 906.2 23.7 911.2 23.7 919.7 18.3 919.7 15.2 909 18.1 906.2"
      />
      <polygon
        className="st2"
        points="377.4 920.8 377.4 946.7 369.3 941.1 369.3 915.2 377.4 920.8"
      />
      <polygon
        className="st2"
        points="381.3 916.7 381.3 942.6 377.4 946.7 377.4 920.8 381.3 916.7"
      />
      <polygon
        className="st2"
        points="357 912.6 357 938.5 347.7 946.7 347.7 920.8 357 912.6"
      />
      <rect className="st2" x="508.6" y="920.8" width="6.1" height="25.9" />
      <polygon
        className="st2"
        points="508.6 920.8 508.6 946.7 500.5 933.6 500.5 907.7 508.6 920.8"
      />
      <polygon
        className="st2"
        points="518.6 911.1 518.6 937 514.6 946.7 514.6 920.8 518.6 911.1"
      />
      <polygon
        className="st2"
        points="430.8 921.7 430.8 947.5 415.6 942.3 415.6 916.4 430.8 921.7"
      />
      <polygon
        className="st2"
        points="243.6 915.9 243.6 941.8 228.5 950.4 228.5 924.5 243.6 915.9"
      />
      <polygon
        className="st2"
        points="438.2 922.2 438.2 948 433.1 950.8 433.1 924.9 438.2 922.2"
      />
      <polygon
        className="st2"
        points="433.1 924.9 433.1 950.8 430.8 947.5 430.8 921.7 433.1 924.9"
      />
      <rect className="st2" x="460.2" y="929.3" width="9.1" height="25.9" />
      <polygon
        className="st2"
        points="460.2 929.3 460.2 955.2 458.2 950.8 458.2 924.9 460.2 929.3"
      />
      <polygon
        className="st2"
        points="228.5 924.5 228.5 950.4 216.9 956.4 216.9 930.5 228.5 924.5"
      />
      <polygon
        className="st2"
        points="38.8 922.6 38.8 948.5 27.5 957.2 27.5 931.3 38.8 922.6"
      />
      <polygon
        className="st2"
        points="27.5 931.3 27.5 957.2 21 952.5 21 926.6 27.5 931.3"
      />
      <polygon
        className="st2"
        points="559.1 924.9 559.1 950.8 550.9 958.7 550.9 932.8 559.1 924.9"
      />
      <rect className="st2" x="544.7" y="932.8" width="6.2" height="25.9" />
      <rect className="st2" x="343.9" y="933.5" width="5.4" height="25.9" />
      <polygon
        className="st2"
        points="343.9 933.5 343.9 959.3 334.6 954.1 334.6 928.2 343.9 933.5"
      />
      <polygon
        className="st2"
        points="95.8 935.3 95.8 961.2 76.1 944 76.1 918.2 95.8 935.3"
      />
      <polygon
        className="st2"
        points="179.5 936.4 179.5 962.3 173.7 959 173.7 933.1 179.5 936.4"
      />
      <polygon
        className="st2"
        points="382.8 933.8 382.8 959.7 379.4 962.3 379.4 936.4 382.8 933.8"
      />
      <polygon
        className="st2"
        points="72.5 936.6 72.5 962.4 70.3 954.2 70.3 928.4 72.5 936.6"
      />
      <polygon
        className="st2"
        points="107.4 936.8 107.4 962.7 95.8 961.2 95.8 935.3 107.4 936.8"
      />
      <polygon
        className="st2"
        points="173.7 933.1 173.7 959 167.9 968.7 167.9 942.8 173.7 933.1"
      />
      <rect className="st2" x="303" y="946.1" width="13.9" height="25.9" />
      <polygon
        className="st2"
        points="321.9 936.8 321.9 962.7 316.9 972 316.9 946.1 321.9 936.8"
      />
      <polygon
        className="st2"
        points="216.9 930.5 216.9 956.4 215 973.9 215 948 216.9 930.5"
      />
      <polygon
        className="st2"
        points="376.6 948.2 376.6 974.1 365.9 963.6 365.9 937.7 376.6 948.2"
      />
      <rect className="st2" x="376.6" y="948.2" width="6.2" height="25.9" />
      <polygon
        className="st2"
        points="215 948 215 973.9 210.4 977.6 210.4 951.7 215 948"
      />
      <rect className="st2" x="351.2" y="953.6" width="4.9" height="25.9" />
      <polygon
        className="st2"
        points="361 950.6 361 976.5 356.1 979.5 356.1 953.6 361 950.6"
      />
      <rect className="st2" x="239.3" y="954.3" width="27.4" height="25.9" />
      <polygon
        className="st2"
        points="167.9 954.3 167.9 980.2 161 984.7 161 958.8 167.9 954.3"
      />
      <polygon
        className="st2"
        points="108.1 959.9 108.1 985.8 107.4 962.7 107.4 936.8 108.1 959.9"
      />
      <polygon
        className="st2"
        points="114.7 965.5 114.7 991.4 108.1 985.8 108.1 959.9 114.7 965.5"
      />
      <polygon
        className="st2"
        points="94.1 945 94.1 970.9 86.7 991.5 86.7 965.6 94.1 945"
      />
      <polygon
        className="st2"
        points="310.9 965.9 310.9 991.8 308.6 977.2 308.6 951.3 310.9 965.9"
      />
      <polygon
        className="st2"
        points="315.1 951.3 319.7 959.3 319.7 965.9 310.9 965.9 308.6 951.3 315.1 951.3"
      />
      <rect className="st2" x="310.9" y="965.9" width="8.9" height="25.9" />
      <polygon
        className="st2"
        points="161 965.9 161 991.8 147.5 992.1 147.5 966.2 161 965.9"
      />
      <rect className="st2" x="192.2" y="966.6" width="10" height="25.9" />
      <polygon
        className="st2"
        points="210.4 962.1 210.4 988 202.3 992.5 202.3 966.6 210.4 962.1"
      />
      <polygon
        className="st2"
        points="192.2 966.6 192.2 992.5 187.6 995.1 187.6 969.2 192.2 966.6"
      />
      <polygon
        className="st2"
        points="187.6 969.2 187.6 995.1 176 987.7 176 961.8 187.6 969.2"
      />
      <polygon
        className="st2"
        points="378.4 972.4 378.4 998.3 362.8 983.6 362.8 957.7 378.4 972.4"
      />
      <polygon
        className="st2"
        points="381.1 967.2 381.1 993.1 378.4 998.3 378.4 972.4 381.1 967.2"
      />
      <polygon
        className="st2"
        points="225.4 975 225.4 1000.9 224.1 991.8 224.1 965.9 225.4 975"
      />
      <rect className="st2" x="225.4" y="975" width="6.9" height="25.9" />
      <polygon
        className="st2"
        points="251.3 975 251.3 1000.9 237 995 237 969.1 251.3 975"
      />
      <polygon
        className="st2"
        points="265.9 969.1 265.9 995 258.6 1000.9 258.6 975 265.9 969.1"
      />
      <rect className="st2" x="251.3" y="975" width="7.3" height="25.9" />
      <polygon
        className="st2"
        points="42.4 975.1 42.4 1000.9 36.8 979.8 36.8 954 42.4 975.1"
      />
      <polygon
        className="st2"
        points="147.5 966.2 147.5 992.1 135.9 1001.1 135.9 975.2 147.5 966.2"
      />
      <polygon
        className="st2"
        points="86.7 965.6 86.7 991.5 55.7 1001.9 55.7 976 86.7 965.6"
      />
      <polygon
        className="st2"
        points="55.7 976 55.7 1001.9 42.4 1000.9 42.4 975.1 55.7 976"
      />
      <polygon
        className="st2"
        points="303 956.9 303 982.8 280.2 1002.9 280.2 977 303 956.9"
      />
      <polygon
        className="st2"
        points="280.2 977 280.2 1002.9 266.7 980.2 266.7 954.3 280.2 977"
      />
      <polygon
        className="st2"
        points="187.4 977 187.4 1002.9 174.7 1007 174.7 981.2 187.4 977"
      />
      <rect className="st2" x="167.9" y="981.2" width="6.8" height="25.9" />
      <polygon
        className="st2"
        points="167.9 981.2 167.9 1007 166.5 998.7 166.5 972.8 167.9 981.2"
      />
      <polygon
        className="st2"
        points="111.6 982.3 111.6 1008.2 105.1 1000.7 105.1 974.8 111.6 982.3"
      />
      <polygon
        className="st2"
        points="318.7 983.2 318.7 1009.1 310.3 996 310.3 970.2 318.7 983.2"
      />
      <polygon
        className="st2"
        points="327.1 976.5 327.1 1002.4 324.4 1009.1 324.4 983.2 327.1 976.5"
      />
      <rect className="st2" x="318.7" y="983.2" width="5.7" height="25.9" />
      <rect className="st2" x="193.6" y="985.8" width="10.4" height="25.9" />
      <polygon
        className="st2"
        points="206.1 979.7 206.1 1005.5 204 1011.7 204 985.8 206.1 979.7"
      />
      <polygon
        className="st2"
        points="193.6 985.8 193.6 1011.7 188.8 1005.7 188.8 979.8 193.6 985.8"
      />
      <polygon
        className="st2"
        points="381.1 989.5 381.1 1015.4 375.9 1013.7 375.9 987.9 381.1 989.5"
      />
      <polygon
        className="st2"
        points="384.5 985.1 384.5 1010.9 381.1 1015.4 381.1 989.5 384.5 985.1"
      />
      <polygon
        className="st2"
        points="113.9 990.8 113.9 1016.7 111.6 1008.2 111.6 982.3 113.9 990.8"
      />
      <polygon
        className="st2"
        points="135.9 975.2 135.9 1001.1 133.6 1016.7 133.6 990.8 135.9 975.2"
      />
      <rect className="st2" x="113.9" y="990.8" width="19.7" height="25.9" />
      <polygon
        className="st2"
        points="172.2 992 172.2 1017.8 167.4 1018 167.4 992.1 172.2 992"
      />
      <rect className="st2" x="222.5" y="997.4" width="7.2" height="25.9" />
      <polygon
        className="st2"
        points="234.1 990.8 234.1 1016.7 229.7 1023.2 229.7 997.4 234.1 990.8"
      />
      <polygon
        className="st2"
        points="222.5 997.4 222.5 1023.2 214 1013.4 214 987.5 222.5 997.4"
      />
      <rect className="st2" x="154.6" y="998.3" width="11" height="25.9" />
      <rect className="st2" x="181.6" y="998.3" width="5.6" height="25.9" />
      <polygon
        className="st2"
        points="189.7 990.8 189.7 1016.7 187.2 1024.2 187.2 998.3 189.7 990.8"
      />
      <polygon
        className="st2"
        points="167.4 992.1 167.4 1018 165.6 1024.2 165.6 998.3 167.4 992.1"
      />
      <polygon
        className="st2"
        points="181.6 998.3 181.6 1024.2 172.2 1017.8 172.2 992 181.6 998.3"
      />
      <polygon
        className="st2"
        points="154.6 998.3 154.6 1024.2 143.2 1013.5 143.2 987.7 154.6 998.3"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="167.4 269 167.4 294.9 159.4 296.4 159.4 270.5 167.4 269"
      />
      <polygon
        className="st2"
        points="159.4 270.5 159.4 296.4 157.6 292.7 157.6 266.8 159.4 270.5"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="183.4 289.4 183.4 315.3 172.6 325.7 172.6 299.9 183.4 289.4"
      />
      <polygon
        className="st2"
        points="172.6 299.9 172.6 325.7 165.1 319.5 165.1 293.6 172.6 299.9"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="142 199.2 142 225.1 131.2 233.8 131.2 207.9 142 199.2"
      />
      <polygon
        className="st2"
        points="131.2 207.9 131.2 233.8 129.6 229.6 129.6 203.7 131.2 207.9"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="824.5 299.6 824.5 325.5 813.3 335.9 813.3 310 824.5 299.6"
      />
      <rect className="st2" x="806.2" y="310" width="7.1" height="25.9" />
      <polygon
        className="st2"
        points="806.2 310 806.2 335.9 796 323.2 796 297.4 806.2 310"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="850 318.6 850 344.5 841.9 348.6 841.9 322.7 850 318.6"
      />
      <polygon
        className="st2"
        points="841.9 322.7 841.9 348.6 833.4 340.4 833.4 314.5 841.9 322.7"
      />
    </g>
    <g className="st3">
      <rect className="st2" x="471.9" y="948.2" width="10.8" height="25.9" />
      <polygon
        className="st2"
        points="471.9 948.2 471.9 974.1 469.2 966.6 469.2 940.7 471.9 948.2"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="29.9 983.4 29.9 1009.3 28.3 1016.7 28.3 990.8 29.9 983.4"
      />
      <rect className="st2" x="21" y="990.8" width="7.3" height="25.9" />
      <polygon
        className="st2"
        points="21 990.8 21 1016.7 14 1010.9 14 985.1 21 990.8"
      />
    </g>
    <g className="st3">
      <rect className="st2" x="14" y="1003.9" width="7.9" height="25.9" />
      <polygon
        className="st2"
        points="22 996.8 22 1003.9 14 1003.9 17.1 996.8 22 996.8"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="134 1015.4 134 1041.3 131.9 1048.6 131.9 1022.7 134 1015.4"
      />
      <polygon
        className="st2"
        points="131.9 1022.7 131.9 1048.6 125.1 1049.7 125.1 1023.8 131.9 1022.7"
      />
      <polygon
        className="st2"
        points="125.1 1023.8 125.1 1049.7 118.3 1040.8 118.3 1014.9 125.1 1023.8"
      />
      <polygon
        className="st2"
        points="129.2 1027.3 129.2 1053.2 123.8 1059.4 123.8 1033.5 129.2 1027.3"
      />
      <polygon
        className="st2"
        points="110.7 1036.8 110.7 1062.7 107.4 1054 107.4 1028.1 110.7 1036.8"
      />
      <polygon
        className="st2"
        points="123.8 1033.5 123.8 1059.4 110.7 1062.7 110.7 1036.8 123.8 1033.5"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="194.9 1023.8 194.9 1049.7 193.8 1059.2 193.8 1033.3 194.9 1023.8"
      />
      <rect className="st2" x="184.5" y="1033.3" width="9.3" height="25.9" />
      <polygon
        className="st2"
        points="184.5 1033.3 184.5 1059.2 182 1050.6 182 1024.7 184.5 1033.3"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="214 994.6 214 1020.4 210.1 1024.2 210.1 998.3 214 994.6"
      />
      <polygon
        className="st2"
        points="210.1 998.3 210.1 1024.2 204.2 1021.6 204.2 995.7 210.1 998.3"
      />
    </g>
    <g className="st3">
      <polygon
        className="st2"
        points="788.1 977.4 788.1 1003.3 727.1 1019.4 727.1 993.5 788.1 977.4"
      />
      <polygon
        className="st2"
        points="727.1 993.5 727.1 1019.4 689 1027.1 689 1001.2 727.1 993.5"
      />
      <polygon
        className="st2"
        points="689 1001.2 689 1027.1 669.5 1034.5 669.5 1008.7 689 1001.2"
      />
      <polygon
        className="st2"
        points="626.2 1013.6 626.2 1039.5 622.8 1025.7 622.8 999.8 626.2 1013.6"
      />
      <polygon
        className="st2"
        points="790.2 987.2 790.2 1013 772.1 1041.4 772.1 1015.5 790.2 987.2"
      />
      <polygon
        className="st2"
        points="669.5 1008.7 669.5 1034.5 633.6 1047.4 633.6 1021.5 669.5 1008.7"
      />
      <polygon
        className="st2"
        points="633.6 1021.5 633.6 1047.4 626.2 1039.5 626.2 1013.6 633.6 1021.5"
      />
      <rect className="st2" x="725" y="1025.6" width="16.2" height="25.9" />
      <polygon
        className="st2"
        points="772.1 1015.5 772.1 1041.4 741.2 1051.4 741.2 1025.6 772.1 1015.5"
      />
      <polygon
        className="st2"
        points="699.2 1027.4 699.2 1053.3 657.1 1051.1 657.1 1025.2 699.2 1027.4"
      />
      <polygon
        className="st2"
        points="725 1025.6 725 1051.4 713.8 1058.9 713.8 1033 725 1025.6"
      />
      <polygon
        className="st2"
        points="713.8 1033 713.8 1058.9 699.2 1053.3 699.2 1027.4 713.8 1033"
      />
      <polygon
        className="st2"
        points="644.4 1033 644.4 1058.9 633.6 1047.4 633.6 1021.5 644.4 1033"
      />
      <rect className="st2" x="644.4" y="1033" width="6.5" height="25.9" />
      <polygon
        className="st2"
        points="657.1 1025.2 657.1 1051.1 650.9 1058.9 650.9 1033 657.1 1025.2"
      />
    </g>
  </>
)
